
/* CARDWORLD Rip Studio: Rip Lab "image-to-code" (7 okt), nieuwe variant NAAST de huidige Rip Lab (start-scene.js).
   window.CWStartI2C = { html(ctx), mount(root, ctx), replay(root), unmount(root) }: hetzelfde contract als window.CWStart.
   Ontwerp: riplab-skills/image-to-code.html (achtergrond per franchise met patroon, bij een wissel een korte
   wereldovergang; vlak Anton-budgetcijfer zonder bovengrens; links de bediening in drie stappen, rechts "Jouw selectie":
   een strook grote 3D-producten met elk een eigen bedieningsbalkje, altijd zichtbare voortgang en knoppen; gsm:
   swipe-carrousel en vaste onderbalk; onderaan je volledige selectie met parallax).
   In de pagina: geen eigen header, begroeting of tabs (die tekent de pagina of de Clean-laag); het kader is de scene zelf.
   Data: ctx.products (alle producten op voorraad van de pagina), beelden via ctx.img, 3D via ctx.mount3D (de gedeelde
   H3D-pool van app.js). De eigen scrollcontainer draagt data-cws-stack: dat is de root van de IntersectionObserver van de
   pool, dus enkel wat in beeld is krijgt een 3D-instantie (6 desktop, 3 gsm), de rest blijft de foto.
   Samenstellen: composeFor uit start-scene.js, met grenzen die meeschalen met het budget (limitsFor) en een eigen
   opslag (cws-budget-i2c-v1, cws-prefs-i2c-v1), zodat deze variant de oude Rip Lab nooit beinvloedt.
   "Alles in mijn mandje": ctx.on.addMany met per product het vertrekpunt (from) van zijn beeld in de strook, zodat de
   vlucht van de pagina zelf vanuit de strook naar het echte mandje gaat; daarna de bevestiging en klapt de mandjelade
   van de pagina kort open (peekCart). 3D: idle wiegen in een gedeelde lus (swayStart).
   Interne scroll: zie de uitleg bij wireScroll onderaan.
   Schakelaar (onderaan dit bestand): ?riplab=nieuw zet deze variant aan voor de rest van de tab (sessionStorage),
   ?riplab=oud zet hem weer uit. Zonder schakelaar blijft window.CWStart de huidige Rip Lab.
   Enkel transform en opacity animeren (plus getallen die tellen), geen vervaging, prefers-reduced-motion respecteren. */
(function () {
  'use strict';

  /* ---------------- teksten (NL is de bron; FR en EN inhoudelijk gelijk) ---------------- */
  var STR = {
    nl: {
      morning: 'Goedemorgen', afternoon: 'Goedemiddag', evening: 'Goedenavond',
      appAria: 'Rip Lab budgetbouwer',
      h1a: 'Jouw budget.', h1b: 'Ons mandje.',
      lead: 'Snel en makkelijk sealed kopen, voor elke franchise. Ideaal als je net begint, een cadeau zoekt of snel wil rippen tijdens de livestream.',
      stepFr: 'Kies je franchise', stepBud: 'Kies je budget', stepPref: 'Wat wil je vooral?',
      numTitle: 'Sleep opzij of typ een bedrag',
      numAria: 'Budget in euro, vanaf 10, zonder bovengrens', rangeTop: '10.000+',
      rangeAria: 'Budget schuif', chipsAria: 'Snelkeuze budget', frAria: 'Franchise',
      fr: { mix: 'Alles', pokemon: 'Pokémon', one_piece: 'One Piece' }, frOther: ['Andere', ' TCG'],
      panelAria: 'Jouw selectie', h2: 'Jouw selectie',
      deckAria: 'Producten in je selectie', stripPrev: 'Vorige producten', stripNext: 'Volgende producten', pagerAria: 'Pagina\'s van je selectie',
      pageAria: function (i, n) { return 'Pagina ' + i + ' van ' + n; },
      empty: 'Voor dit bedrag vinden we nu niets in deze reeks. Kies een hoger budget of probeer Alles.',
      setMin: function (p) { return 'Zet budget op ' + eurInt(p); }, showAll: 'Toon alles',
      carAria: 'Producten in je selectie', prev: 'Vorig product', next: 'Volgend product',
      slideOf: function (i, n, ti) { return i + ' van ' + n + ': ' + ti; },
      dotAria: function (i, n) { return 'Product ' + i + ' van ' + n; },
      of: function (a, b) { return eur(a) + ' van ' + eurInt(b); },
      over: function (r) { return eur(r) + ' over'; },
      budgetMark: function (b) { return eurInt(b) + ' budget'; },
      units: function (u) { return u + (u === 1 ? ' stuk' : ' stuks'); },
      pSub: function (u) { return STR.nl.units(u) + '. Sleep een product om het te draaien.'; },
      fSub: function (u, tot) { return STR.nl.units(u) + ', samen ' + eur(tot) + '. Sleep een product om het te draaien.'; },
      fSubEmpty: 'Alles wat in je budget past, op een rij.',
      addAll: 'Alles in mijn mandje', added: 'In je mandje',
      reroll: 'Andere selectie', rerollNew: 'Stel een nieuwe samen',
      onlyOne: 'Dit is de enige combinatie binnen je budget',
      noMix: 'Voor dit bedrag is er in deze reeks geen andere mix. Kies een hoger budget of probeer Alles.',
      noMixAll: 'Voor dit bedrag is er geen andere mix. Kies een hoger budget.',
      noMixF: 'Binnen je keuzes is er voor dit bedrag geen andere mix. Tik op Alle soorten tonen of kies een hoger budget.',
      clearF: 'Alle soorten tonen', inMix: 'in het aanbod',
      fNote: function (lbl, fr, n, st) {
        return 'Je koos ' + lbl + ': ' + (st === 'types' ? fr + ' heeft ' + (n === 1 ? '1 product' : n + ' producten') + ' van die soort binnen je budget.' :
          st === 'packs' ? 'dan nemen we enkel kleinere producten.' : 'dan nemen we hoogstens een paar grote producten.');
      },
      moreHint: 'Bekijk je volledige selectie',
      fullAria: 'Je volledige selectie', fH1: 'Je volledige', fH2: 'selectie',
      fEmpty: 'Je selectie is leeg. Kies een budget of tik op Andere selectie voor een nieuwe mix.',
      under: 'Meer vinden we nu niet binnen je keuzes. Probeer Alles of een andere soort voor de rest van je budget.',
      capNote: function (n) { return 'Per product stellen we hoogstens ' + n + ' stuks voor, daarom blijft een deel van je budget over.'; },
      minus: 'Eentje minder', plus: 'Eentje meer', each: function (p) { return 'à ' + p; },
      swap: 'Wissel voor een alternatief', swapTitle: 'Wissel voor iets in dezelfde prijsklasse',
      remove: 'Verwijder uit selectie', noAlt: 'Geen alternatief in dezelfde prijsklasse binnen je budget',
      openAria: function (ti) { return 'Open ' + ti; },
      confirmLine: function (n, tot) { return (n === 1 ? '1 product' : n + ' producten') + ' in je mandje, ' + eur(tot); },
      confirmCart: 'Bekijk mijn mandje', confirmUndo: 'Ongedaan maken',
      typeAria: 'Soort product', styleAria: 'Samenstelling', typeAll: 'Alles', typeMore: 'Meer', typeLess: 'Minder',
      types: { packs: 'Packs', blister: 'Blisters', bundles: 'Bundels', etb: 'ETB', boxen: 'Boxen', collecties: 'Collecties', cases: 'Cases' },
      style: { packs: 'Meer packs', mixed: 'Mix', big: 'Eén topstuk' },
      emptyType: 'Voor dit bedrag vinden we nu niets van deze soort. Kies een hoger budget of een andere soort.', allTypes: 'Alle soorten',
      bMinus: 'Budget lager', bPlus: 'Budget hoger',
      lsw: 'Ontwerp linkerkolom', lnames: { a: 'Compact paneel', b: 'Zinbouwer', c: 'Bedieningsdek' },
      /* zinbouwer: "Ik wil [Pokémon] voor [€ 225], vooral [packs], [als mix]." */
      sA: 'Ik wil', sB: 'voor', sC: 'vooral', sEnd: '.', sAnd: ' en ',
      sFr: { mix: 'van alles', pokemon: 'Pokémon', one_piece: 'One Piece', other: 'andere TCG' },
      sTypesNone: 'alle soorten', sStyle: { mixed: 'als mix', packs: 'met veel packs', big: 'met één topstuk' },
      sHint: 'Tik op een gekleurd woord om het aan te passen.', popStyle: 'Hoe stellen we samen?'
    },
    fr: {
      morning: 'Bonjour', afternoon: 'Bon après-midi', evening: 'Bonsoir',
      appAria: 'Rip Lab, composeur de budget',
      h1a: 'Ton budget.', h1b: 'Notre panier.',
      lead: 'Acheter du sealed vite et facilement, pour chaque franchise. Idéal si tu débutes, si tu cherches un cadeau ou si tu veux ripper vite pendant le livestream.',
      stepFr: 'Choisis ta franchise', stepBud: 'Choisis ton budget', stepPref: 'Que veux-tu surtout\u202f?',
      numTitle: 'Glisse sur le côté ou tape un montant',
      numAria: 'Budget en euros, à partir de 10, sans limite', rangeTop: '10\u202f000+',
      rangeAria: 'Curseur du budget', chipsAria: 'Budget rapide', frAria: 'Franchise',
      fr: { mix: 'Tout', pokemon: 'Pokémon', one_piece: 'One Piece' }, frOther: ['Autres', ' TCG'],
      panelAria: 'Ta sélection', h2: 'Ta sélection',
      deckAria: 'Produits de ta sélection', stripPrev: 'Produits précédents', stripNext: 'Produits suivants', pagerAria: 'Pages de ta sélection',
      pageAria: function (i, n) { return 'Page ' + i + ' sur ' + n; },
      empty: 'Pour ce montant, nous ne trouvons rien dans cette gamme pour le moment. Choisis un budget plus élevé ou essaie Tout.',
      setMin: function (p) { return 'Mettre le budget à ' + eurInt(p); }, showAll: 'Tout montrer',
      carAria: 'Produits de ta sélection', prev: 'Produit précédent', next: 'Produit suivant',
      slideOf: function (i, n, ti) { return i + ' sur ' + n + '\u202f: ' + ti; },
      dotAria: function (i, n) { return 'Produit ' + i + ' sur ' + n; },
      of: function (a, b) { return eur(a) + ' sur ' + eurInt(b); },
      over: function (r) { return eur(r) + ' restants'; },
      budgetMark: function (b) { return 'budget ' + eurInt(b); },
      units: function (u) { return u + (u === 1 ? ' article' : ' articles'); },
      pSub: function (u) { return STR.fr.units(u) + '. Fais glisser un produit pour le faire tourner.'; },
      fSub: function (u, tot) { return STR.fr.units(u) + ', ' + eur(tot) + ' au total. Fais glisser un produit pour le faire tourner.'; },
      fSubEmpty: 'Tout ce qui entre dans ton budget, en un coup d’œil.',
      addAll: 'Tout dans mon panier', added: 'Dans ton panier',
      reroll: 'Autre sélection', rerollNew: 'Compose une nouvelle sélection',
      onlyOne: 'C’est la seule combinaison possible avec ce budget',
      noMix: 'Pour ce montant, il n’y a pas d’autre mix dans cette gamme. Choisis un budget plus élevé ou essaie Tout.',
      noMixAll: 'Pour ce montant, il n’y a pas d’autre mix. Choisis un budget plus élevé.',
      noMixF: 'Dans tes choix, il n’y a pas d’autre mix pour ce montant. Touche Afficher tous les types ou choisis un budget plus élevé.',
      clearF: 'Afficher tous les types', inMix: 'l’offre',
      fNote: function (lbl, fr, n, st) {
        return 'Tu as choisi ' + lbl + '\u202f: ' + (st === 'types' ? (fr === 'l’offre' ? 'l’offre' : fr) + ' compte ' + (n === 1 ? '1 produit' : n + ' produits') + ' de ce type dans ton budget.' :
          st === 'packs' ? 'nous prenons donc seulement de petits produits.' : 'nous prenons donc au plus quelques grands produits.');
      },
      moreHint: 'Voir ta sélection complète',
      fullAria: 'Ta sélection complète', fH1: 'Ta sélection', fH2: 'complète',
      fEmpty: 'Ta sélection est vide. Choisis un budget ou touche Autre sélection pour un nouveau mix.',
      under: 'Nous ne trouvons rien de plus dans tes choix pour le moment. Essaie Tout ou un autre type pour le reste de ton budget.',
      capNote: function (n) { return 'Nous proposons au plus ' + n + ' exemplaires par produit, c’est pourquoi une partie de ton budget reste libre.'; },
      minus: 'Un de moins', plus: 'Un de plus', each: function (p) { return 'à ' + p; },
      swap: 'Échanger contre une alternative', swapTitle: 'Échanger contre un produit de la même gamme de prix',
      remove: 'Retirer de la sélection', noAlt: 'Pas d’alternative dans la même gamme de prix avec ton budget',
      openAria: function (ti) { return 'Ouvrir ' + ti; },
      confirmLine: function (n, tot) { return (n === 1 ? '1 produit' : n + ' produits') + ' dans ton panier, ' + eur(tot); },
      confirmCart: 'Voir mon panier', confirmUndo: 'Annuler',
      typeAria: 'Type de produit', styleAria: 'Composition', typeAll: 'Tout', typeMore: 'Plus', typeLess: 'Moins',
      types: { packs: 'Boosters', blister: 'Blisters', bundles: 'Bundles', etb: 'ETB', boxen: 'Boîtes', collecties: 'Coffrets', cases: 'Cases' },
      style: { packs: 'Plus de boosters', mixed: 'Mix', big: 'Une pièce phare' },
      emptyType: 'Pour ce montant, nous ne trouvons rien de ce type pour le moment. Choisis un budget plus élevé ou un autre type.', allTypes: 'Tous les types',
      bMinus: 'Budget plus bas', bPlus: 'Budget plus haut',
      lsw: 'Design de la colonne de gauche', lnames: { a: 'Panneau compact', b: 'Phrase', c: 'Pupitre' },
      sA: 'Je veux', sB: 'pour', sC: 'surtout', sEnd: '.', sAnd: ' et ',
      sFr: { mix: 'un peu de tout', pokemon: 'Pokémon', one_piece: 'One Piece', other: 'd’autres TCG' },
      sTypesNone: 'tous les types', sStyle: { mixed: 'en mix', packs: 'avec beaucoup de boosters', big: 'avec une pièce phare' },
      sHint: 'Touche un mot en couleur pour le modifier.', popStyle: 'Comment composer ?'
    },
    en: {
      morning: 'Good morning', afternoon: 'Good afternoon', evening: 'Good evening',
      appAria: 'Rip Lab budget builder',
      h1a: 'Your budget.', h1b: 'Our basket.',
      lead: 'Buy sealed quickly and easily, for every franchise. Ideal if you are just starting out, looking for a gift or want a quick rip during the livestream.',
      stepFr: 'Pick your franchise', stepBud: 'Pick your budget', stepPref: 'What do you want most?',
      numTitle: 'Drag sideways or type an amount',
      numAria: 'Budget in euros, from 10, no upper limit', rangeTop: '10,000+',
      rangeAria: 'Budget slider', chipsAria: 'Quick budget', frAria: 'Franchise',
      fr: { mix: 'All', pokemon: 'Pokémon', one_piece: 'One Piece' }, frOther: ['Other', ' TCG'],
      panelAria: 'Your selection', h2: 'Your selection',
      deckAria: 'Products in your selection', stripPrev: 'Previous products', stripNext: 'Next products', pagerAria: 'Pages of your selection',
      pageAria: function (i, n) { return 'Page ' + i + ' of ' + n; },
      empty: 'We cannot find anything in this range for this amount right now. Pick a higher budget or try All.',
      setMin: function (p) { return 'Set budget to ' + eurInt(p); }, showAll: 'Show all',
      carAria: 'Products in your selection', prev: 'Previous product', next: 'Next product',
      slideOf: function (i, n, ti) { return i + ' of ' + n + ': ' + ti; },
      dotAria: function (i, n) { return 'Product ' + i + ' of ' + n; },
      of: function (a, b) { return eur(a) + ' of ' + eurInt(b); },
      over: function (r) { return eur(r) + ' under budget'; },
      budgetMark: function (b) { return eurInt(b) + ' budget'; },
      units: function (u) { return u + (u === 1 ? ' item' : ' items'); },
      pSub: function (u) { return STR.en.units(u) + '. Drag a product to turn it.'; },
      fSub: function (u, tot) { return STR.en.units(u) + ', ' + eur(tot) + ' in total. Drag a product to turn it.'; },
      fSubEmpty: 'Everything that fits your budget, in one place.',
      addAll: 'All in my cart', added: 'In your cart',
      reroll: 'Another pick', rerollNew: 'Put together a new pick',
      onlyOne: 'This is the only combination within your budget',
      noMix: 'There is no other mix in this range for this amount. Pick a higher budget or try All.',
      noMixAll: 'There is no other mix for this amount. Pick a higher budget.',
      noMixF: 'Within your choices there is no other mix for this amount. Tap Show all types or pick a higher budget.',
      clearF: 'Show all types', inMix: 'the range',
      fNote: function (lbl, fr, n, st) {
        return 'You chose ' + lbl + ': ' + (st === 'types' ? fr + ' has ' + (n === 1 ? '1 product' : n + ' products') + ' of that type within your budget.' :
          st === 'packs' ? 'so we only take smaller products.' : 'so we take a few big products at most.');
      },
      moreHint: 'See your full selection',
      fullAria: 'Your full selection', fH1: 'Your full', fH2: 'selection',
      fEmpty: 'Your selection is empty. Pick a budget or tap Another pick for a new mix.',
      under: 'We cannot find more within your choices right now. Try All or another type for the rest of your budget.',
      capNote: function (n) { return 'We suggest at most ' + n + ' of each product, so part of your budget stays open.'; },
      minus: 'One less', plus: 'One more', each: function (p) { return p + ' each'; },
      swap: 'Swap for an alternative', swapTitle: 'Swap for something in the same price range',
      remove: 'Remove from selection', noAlt: 'No alternative in the same price range within your budget',
      openAria: function (ti) { return 'Open ' + ti; },
      confirmLine: function (n, tot) { return (n === 1 ? '1 product' : n + ' products') + ' in your cart, ' + eur(tot); },
      confirmCart: 'View my cart', confirmUndo: 'Undo',
      typeAria: 'Product type', styleAria: 'Composition', typeAll: 'All', typeMore: 'More', typeLess: 'Less',
      types: { packs: 'Packs', blister: 'Blisters', bundles: 'Bundles', etb: 'ETB', boxen: 'Boxes', collecties: 'Collections', cases: 'Cases' },
      style: { packs: 'More packs', mixed: 'Mix', big: 'One top piece' },
      emptyType: 'For this amount there is nothing of this type right now. Choose a higher budget or another type.', allTypes: 'All types',
      bMinus: 'Lower budget', bPlus: 'Higher budget',
      lsw: 'Left column design', lnames: { a: 'Compact panel', b: 'Sentence', c: 'Control deck' },
      sA: 'I want', sB: 'for', sC: 'mostly', sEnd: '.', sAnd: ' and ',
      sFr: { mix: 'a bit of everything', pokemon: 'Pokémon', one_piece: 'One Piece', other: 'other TCGs' },
      sTypesNone: 'all types', sStyle: { mixed: 'as a mix', packs: 'with lots of packs', big: 'with one top piece' },
      sHint: 'Tap a coloured word to change it.', popStyle: 'How should we mix it?'
    }
  };
  function strFor(lang) { return STR[lang] || STR.nl; }

  /* ---------------- hulpjes ---------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function round2(n) { return Math.round((n + 1e-9) * 100) / 100; }
  function thousands(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  /* zelfde notatie als de rest van de pagina: euroteken, spatie, punt voor duizendtallen, komma voor centen */
  function eur(n) { var v = round2(n || 0).toFixed(2).split('.'); return '€ ' + thousands(v[0]) + ',' + v[1]; }
  function eurInt(n) { return '€ ' + thousands(String(Math.round(n || 0))); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function prefersReduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function brusselsHour() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Brussels', hour: '2-digit', hour12: false }).formatToParts(new Date());
      var h = parts.filter(function (p) { return p.type === 'hour'; })[0];
      return h ? parseInt(h.value, 10) % 24 : new Date().getHours();
    } catch (e) { return new Date().getHours(); }
  }
  function greetingKey() { var h = brusselsHour(); return h >= 5 && h < 12 ? 'morning' : h >= 12 && h < 18 ? 'afternoon' : 'evening'; }
  /* eigen opslag (8 okt): de oude Rip Lab leest cws-budget-v1 en cws-prefs-v3. Deze variant schrijft daar niets meer in
     (en leest ze ook niet), zodat een keuze hier nooit verandert wat de oude samenstelt, en een oude keuze (bv. Packs)
     hier niet stilletjes het mandje beperkt. */
  var LS_KEY = 'cws-budget-i2c-v1';
  function loadSeed() {
    try { var o = JSON.parse(window.localStorage.getItem(LS_KEY) || 'null'); return o && typeof o.seed === 'number' ? o.seed : 0; } catch (e) { return 0; }
  }
  function saveSeed(budget, franchise, seed) {
    try { window.localStorage.setItem(LS_KEY, JSON.stringify({ budget: budget, franchise: franchise, seed: seed })); } catch (e) { /* geen opslag: negeren */ }
  }

  /* ================= samenstellen: letterlijk uit start-scene.js (zelfde resultaat als de huidige Rip Lab) ================= */
  /* ---------------- voorkeur producttype: enkel categorieen die echte producten bevatten
     (nooit accessoires), afgeleid uit de velden type/kind van ctx.products (de chips: paintPrefs). ---------------- */
  var TYPE_CAT_DEFS = [
    { id: 'packs', match: function (p) { return p.kind === 'Booster Pack' || p.kind === 'Double Pack Set'; } },
    { id: 'blister', match: function (p) { return p.kind === 'Blister'; } },
    { id: 'bundles', match: function (p) { return p.kind === 'Booster Bundle'; } },
    { id: 'etb', match: function (p) { return p.kind === 'Elite Trainer Box'; } },
    { id: 'boxen', match: function (p) { return p.kind === 'Booster Box'; } },
    { id: 'collecties', match: function (p) { return p.kind === 'Ultra Premium Collection' || p.kind === 'Collectie box' || p.kind === 'Tin'; } },
    { id: 'cases', match: function (p) { return p.kind !== 'Booster Bundle' && /display|case/i.test(p.kind || ''); } }
  ];
  function classifyProduct(p) {
    for (var i = 0; i < TYPE_CAT_DEFS.length; i++) { if (TYPE_CAT_DEFS[i].match(p)) return TYPE_CAT_DEFS[i].id; }
    return null;
  }
  var LS_PREFS_KEY = 'cws-prefs-i2c-v1';
  var STYLE_VALS = ['packs', 'mixed', 'big'], PURPOSE_VALS = ['stream', 'seal', 'gift'];
  /* eigenaar 7 okt: eerder gekochte producten nooit meer standaard weglaten (avoid uit); wie het zelf aanzet in Filters, mag */
  /* handles die de klant eerder kocht (ctx.history.bought), voor het label "Eerder gekocht" */
  function boughtSetOf(ctx) { var s = {}; ((ctx && ctx.history && ctx.history.bought) || []).forEach(function (b) { if (b && b.handle) s[b.handle] = 1; }); return s; }
  function defaultTypePrefs() { return { mode: 'auto', types: [], style: 'mixed', purpose: 'stream', avoid: false }; }
  function cleanTypePrefs(obj) {
    var d = defaultTypePrefs();
    if (!obj || typeof obj !== 'object') return d;
    d.mode = obj.mode === 'manual' ? 'manual' : 'auto';
    d.types = Array.isArray(obj.types) ? obj.types.filter(function (x) { return typeof x === 'string'; }) : [];
    if (STYLE_VALS.indexOf(obj.style) !== -1) d.style = obj.style;
    if (PURPOSE_VALS.indexOf(obj.purpose) !== -1) d.purpose = obj.purpose;
    /* v3: enkel een expliciete keuze telt; v2 en v1 hadden avoid standaard aan en worden genegeerd */
    if (obj.v === 3 && obj.avoid === true) d.avoid = true;
    return d;
  }
  function loadTypePrefs() {
    try {
      if (!window.localStorage) return null;
      var raw = window.localStorage.getItem(LS_PREFS_KEY);
      if (!raw) return null;
      return cleanTypePrefs(JSON.parse(raw));
    } catch (e) { return null; }
  }
  function saveTypePrefs(tp) {
    try {
      if (!window.localStorage) return;
      window.localStorage.setItem(LS_PREFS_KEY, JSON.stringify({ v: 3, mode: tp.mode, types: tp.types, style: tp.style, purpose: tp.purpose, avoid: tp.avoid === true }));
    } catch (e) { /* stil negeren, geen opslag beschikbaar */ }
  }
  /* alleen categorieen die nu echt bestaan blijven over: een feed-wijziging kan een oude
     voorkeur anders laten verwijzen naar een categorie die niet meer voorkomt */
  function resolveTypePrefs(availableCatIds) {
    var tp = loadTypePrefs() || defaultTypePrefs();
    tp.types = tp.types.filter(function (id) { return availableCatIds.indexOf(id) !== -1; });
    return tp;
  }

  /* ---------------- "laat CARDIX kiezen": weegt ctx.history (optioneel) per categorie, aankopen
     het zwaarst, dan bekeken, recentere items wegen zwaarder, een match met de huidige
     franchise ook. zonder (bruikbare) geschiedenis: lege lijst, dan geldt de bestaande
     slimme mix en het regeltje "CARDIX kiest een gevarieerde mix". ---------------- */
  function deriveHistoryTypes(ctx, franchiseKey) {
    var history = ctx.history;
    var bought = (history && history.bought) || [];
    var viewed = (history && history.viewed) || [];
    if (!bought.length && !viewed.length) return [];
    var byHandle = {};
    (ctx.products || []).forEach(function (p) { byHandle[p.handle] = p; });
    var score = {};
    function add(handle, weight, recencyBonus) {
      var p = byHandle[handle];
      if (!p || p.type === 'acc') return;
      var id = classifyProduct(p);
      if (!id) return;
      var franchiseBonus = productMatchesFranchise(p, franchiseKey) ? 1.4 : 1;
      score[id] = (score[id] || 0) + weight * franchiseBonus * recencyBonus;
    }
    bought.slice().sort(function (a, b) { return (b.at || 0) - (a.at || 0); })
      .forEach(function (b, i) { add(b.handle, 3 * Math.max(1, b.qty || 1), 1 / (1 + i * 0.25)); });
    viewed.slice().sort(function (a, b) { return (b.at || 0) - (a.at || 0); })
      .forEach(function (v, i) { add(v.handle, 1, 1 / (1 + i * 0.25)); });
    var ids = Object.keys(score).sort(function (a, b) { return score[b] - score[a]; });
    return ids.slice(0, 2);
  }
  /* de voorkeur die echt meetelt bij het samenstellen, in volgorde van sterkte:
     1. zelf gekozen types (hard: enkel die types zodra er een past)
     2. doel Sealed bewaren / Cadeau (PURPOSE_TYPES, hard: geen losse packs)
     3. samenstelling Veel packs / Eén groot stuk (STYLE_TYPES, zacht gewicht)
     4. CARDIX-modus: de types uit ctx.history (zacht), met stijl gemengd, doel stream, vermijden aan
     style, purpose en avoid sturen verder composeBasketCore en composeFor. */
  var PURPOSE_TYPES = { seal: ['boxen', 'etb', 'collecties', 'bundles'], gift: ['etb', 'collecties'] };
  var STYLE_TYPES = { packs: ['packs', 'blister'], big: ['etb', 'boxen', 'collecties', 'bundles'] };
  function effectiveTypePrefs(ctx, state) {
    var tp = state.typePrefs || defaultTypePrefs();
    if (tp.mode === 'manual') {
      var out = { mode: 'manual', style: tp.style, purpose: tp.purpose, avoid: tp.avoid === true, types: [], source: 'none', strict: false };
      if (tp.types.length) { out.types = tp.types.slice(); out.source = 'manual'; out.strict = true; }
      else if (PURPOSE_TYPES[tp.purpose]) { out.types = PURPOSE_TYPES[tp.purpose].slice(); out.source = 'purpose'; out.strict = true; }
      else if (STYLE_TYPES[tp.style]) { out.types = STYLE_TYPES[tp.style].slice(); out.source = 'style'; }
      return out;
    }
    var hist = deriveHistoryTypes(ctx, state.franchise);
    return { mode: 'auto', style: 'mixed', purpose: 'stream', avoid: (state.typePrefs && state.typePrefs.avoid === true), types: hist, source: hist.length ? 'cardix' : 'none', strict: false };
  }

  function boughtMap(ctx) {
    var m = {}, list = (ctx.history && ctx.history.bought) || [];
    list.forEach(function (b) { if (b && b.handle) m[b.handle] = true; });
    return m;
  }

  function productMatchesFranchise(p, key) {
    if (key === 'mix') return true; /* mix van alle franchises (eigenaar 5 okt) */
    if (key === 'pokemon') return p.franchise === 'Pokémon';
    if (key === 'one_piece') return p.franchise === 'One Piece';
    return p.franchise !== 'Pokémon' && p.franchise !== 'One Piece';
  }

  /* ---------------- seeded shuffle: enkel kandidaten met een gelijkaardige prijs (binnen 50%
     van de vorige, dezelfde orde van grootte) wisselen van volgorde, deterministisch per seed.
     mulberry32, geen afhankelijkheid. ---------------- */
  function mulberry32(seed) {
    var a = seed >>> 0;
    return function () {
      a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function seededShuffle(arr, seedNum) {
    var rng = mulberry32(seedNum >>> 0);
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(rng() * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }
  function seededPriceOrder(pool, seed) {
    var sorted = pool.slice().sort(function (a, b) { return b.price - a.price; });
    var clusters = [], cur = [];
    sorted.forEach(function (p) {
      if (!cur.length) { cur.push(p); return; }
      var prevPrice = cur[cur.length - 1].price;
      var ratio = prevPrice > 0 ? (prevPrice - p.price) / prevPrice : 0;
      if (ratio <= 0.5) cur.push(p); else { clusters.push(cur); cur = [p]; }
    });
    if (cur.length) clusters.push(cur);
    var out = [];
    clusters.forEach(function (cluster, ci) {
      var shuffled = cluster.length > 1 ? seededShuffle(cluster, ((seed * 2654435761) + ci * 97) >>> 0) : cluster;
      out = out.concat(shuffled);
    });
    return out;
  }

  /* ---------------- mandje samenstellen, deterministisch per (budget, franchise, seed) ----------------
     eerst het duurste product tot ongeveer 70% van het budget, daarna aanvullen van duur naar
     goedkoop (packs tot 6 stuks), nooit boven het budget, hoogstens 8 regels, dan een tweede
     vulronde van goedkoop naar duur om het budget zo dicht mogelijk te benaderen. */
  var ROWS_MAX = 8, PACK_QTY_MAX = 6, PREF_SHARE = 0.8;
  /* zelf bijstellen mag bij elk product, ook dozen (eigenaar 5 okt: "bij een single product kan ik geen meer toevoegen");
     het voorstel van CARDIX zelf houdt PACK_QTY_MAX en 1 per doos */
  var MANUAL_QTY_MAX = 10;
  /* harde grens per product, ook bij een enorm budget: elke 20 stuks is in de pagina een eigen vlucht naar het mandje
     (app.js addMany), dus duizenden stuks zouden de pagina laten vastlopen. Blijft het budget daardoor onbenut, dan zegt
     de melding dat eerlijk (capNote). */
  var QTY_CAP = 40;
  /* budget zonder bovengrens (eigenaar 8 okt: "je budget mag ongelimiteerd zijn"): de grenzen schalen mee met het budget,
     zodat een groot budget ook echt gevuld raakt. Tot 250 euro exact het oude gedrag (8 regels, 6 packs, 1 doos, 10 met
     de hand); daarboven groeien het aantal regels (wortel van het budget, tot 30) en, in de vulronde, de aantallen. Nooit boven het budget: tryAdd blijft de enige plek die toevoegt. */
  function limitsFor(budget, style) {
    var b = Math.max(0, +budget || 0), f = Math.max(1, b / 250);
    var rows = style === 'big' ? Math.max(2, Math.min(8, Math.round(2 * Math.sqrt(Math.max(1, b / 500))))) : Math.max(ROWS_MAX, Math.min(30, Math.round(ROWS_MAX * Math.sqrt(f))));
    /* packs en dozen per regel blijven in de eerste vulrondes zoals altijd (6 en 1): zo komen er eerst meer verschillende
       producten in (dozen erbij); pas de vulronde daarna (boost) laat de aantallen meegroeien */
    return { rows: rows, pack: PACK_QTY_MAX, box: 1, manual: Math.max(MANUAL_QTY_MAX, Math.ceil(b / 200)) };
  }
  /* prefTypes (optioneel): categorie-id's uit TYPE_CAT_DEFS die zwaarder mogen wegen, ongeveer
     tot 80% van het budget waar dat kan; de rest vult enkel aan. is er binnen budget en
     franchise niks van het gekozen type, dan valt het resultaat terug op de normale mix
     (result.prefFallback = true, zodat de UI "hier is een alternatief" kan tonen). */
  /* korte productnaam voor kaartjes: franchise-voorvoegsel, haakjes en het producttype
     eraf (dat type staat apart als klein regeltje), zodat de naam op 1 regel past */
  var KIND_SUFFIX_RE = /\s*[-:]?\s*(Sleeved Booster Pack|Booster Pack|Booster Box|Elite Trainer Box|Booster Bundle Display|Booster Bundle|Mini Tin|Tin|Ultra Premium Collection|Super Premium Collection|Collection Box|Double Pack Set|2-pack Blister|Blister|Bundle)\b.*$/i;
  function shortTitle(title) {
    var s = String(title || '').replace(/^Pok[eé]mon TCG:\s*/i, '').replace(/^Disney Lorcana Set \d+:\s*/i, 'Lorcana ')
      .replace(/^One Piece( Card Game)?:?\s*/i, '').replace(/\s*\([^)]*\)/g, '').trim();
    var s2 = s.replace(KIND_SUFFIX_RE, '').replace(/[\s\-:&]+$/, '').trim();
    return s2 || s;
  }
  var KIND_LABELS = {
    nl: { 'Collectie box': 'Collectiebox', 'Double Pack Set': 'Double Pack Set' },
    fr: { 'Collectie box': 'Coffret collection', 'Tin': 'Tin', 'Blister': 'Blister' },
    en: { 'Collectie box': 'Collection box' }
  };
  function kindLabel(ctx, handle) {
    var p = null, list = ctx.products || [];
    for (var i = 0; i < list.length; i++) { if (list[i] && list[i].handle === handle) { p = list[i]; break; } }
    var k = p && p.kind ? p.kind : '';
    if (!k) return '';
    var map = KIND_LABELS[ctx.lang] || KIND_LABELS.nl;
    return map[k] || k;
  }

  /* eigen categoriekeuze (strict) is hard: zodra er binnen budget en franchise minstens 1
     product van die categorie past, komen er ENKEL producten van die categorie in (eigenaar
     5 okt: "ik klik ETB's maar toch geeft die andere suggesties"). Past er geen enkel, dan
     de bestaande terugval met uitleg. CARDIX-keuze (niet strict) blijft een zachte weging. */
  function composeBasket(products, budget, franchiseKey, seed, prefTypes, strict, opts) {
    if (strict && prefTypes && prefTypes.length) {
      var strictPool = (products || []).filter(function (p) {
        var id = p && classifyProduct(p);
        return p && p.av !== false && p.type !== 'acc' && productMatchesFranchise(p, franchiseKey) && id && prefTypes.indexOf(id) !== -1;
      });
      var anyFits = strictPool.some(function (p) { return p.price <= budget + 1e-9; });
      if (anyFits) {
        var r = composeBasketCore(strictPool, budget, 'mix', seed, null, opts);
        r.prefFallback = false;
        return r;
      }
    }
    return composeBasketCore(products, budget, franchiseKey, seed, prefTypes, opts);
  }
  /* composeFor: de ene plek waar alle voorkeuren samenkomen (eigen types/doel/stijl via effectiveTypePrefs,
     "vermijd wat ik al kocht" via ctx.history.bought). st heeft budget, franchise en typePrefs. Blijft er na het
     vermijden niets over, dan valt het terug op de volledige lijst zodat het scherm nooit leeg wordt door deze optie. */
  function composeFor(ctx, st, products, seed) {
    var eff = effectiveTypePrefs(ctx, st);
    var opts = { style: eff.style };
    var src = products || [];
    var res = null;
    if (eff.avoid) {
      var bought = boughtMap(ctx);
      var kept = src.filter(function (p) { return !(p && bought[p.handle]); });
      if (kept.length && kept.length !== src.length) {
        res = composeBasket(kept, st.budget, st.franchise, seed, eff.types, eff.strict, opts);
        /* vaste soort: een terugval op andere soorten zonder de gekochte producten telt niet, dan de volledige lijst */
        if (!res.items.length || (eff.strict && res.prefFallback === true)) res = null;
      }
    }
    if (!res) res = composeBasket(src, st.budget, st.franchise, seed, eff.types, eff.strict, opts);
    res.eff = eff;
    return res;
  }
  /* opts.style stuurt de samenstelling: 'packs' = pool beperkt tot kleine producten (tot 20% van het budget) met een
     hoofdproduct van ten hoogste 25% van het budget, dus veel regels en aantallen; 'big' = het hoofdproduct mag het
     hele budget vullen en er zijn hoogstens 2 regels; 'mixed' = het gedrag van altijd (70%, 8 regels). */
  function composeBasketCore(products, budget, franchiseKey, seed, prefTypes, opts) {
    var style = (opts && opts.style) || 'mixed';
    var LIM = limitsFor(budget, style);
    var rowsMax = LIM.rows;
    var anchorShare = style === 'big' ? 1 : (style === 'packs' ? 0.25 : 0.7);
    var pool = (products || []).filter(function (p) {
      return p && p.av !== false && p.type !== 'acc' && productMatchesFranchise(p, franchiseKey);
    });
    if (!pool.length) return { items: [], total: 0 };
    if (style === 'packs') {
      var smallPool = pool.filter(function (p) { return p.price <= Math.max(budget * 0.2, 1) + 1e-9; });
      if (smallPool.length >= 2) pool = smallPool;
    }
    var hasPref = !!(prefTypes && prefTypes.length);
    var isPreferred = function (p) { var id = classifyProduct(p); return !!(id && prefTypes.indexOf(id) !== -1); };
    var preferredPool = hasPref ? pool.filter(isPreferred) : [];
    var usedFallback = hasPref && preferredPool.length === 0;

    var byPriceDesc = seededPriceOrder(pool, seed || 0);
    var byPriceDescPref = hasPref && preferredPool.length ? seededPriceOrder(preferredPool, seed || 0) : [];

    var anchor = null, anchorFromPref = false;
    for (var ip = 0; ip < byPriceDescPref.length; ip++) {
      if (byPriceDescPref[ip].price <= budget * anchorShare + 1e-9) { anchor = byPriceDescPref[ip]; anchorFromPref = true; break; }
    }
    /* past er van het gekozen type niets onder 70%, dan mag het hoofdproduct van dat type
       tot het volledige budget gaan (een ETB van 99,99 bij 135 euro moet erin) */
    if (!anchor) {
      var prefFit = byPriceDescPref.filter(function (p) { return p.price <= budget + 1e-9; });
      if (prefFit.length) { anchor = prefFit[0]; anchorFromPref = true; }
    }
    if (!anchor) {
      for (var i = 0; i < byPriceDesc.length; i++) {
        if (byPriceDesc[i].price <= budget * anchorShare + 1e-9) { anchor = byPriceDesc[i]; break; }
      }
    }
    if (!anchor) {
      var fits = byPriceDesc.filter(function (p) { return p.price <= budget + 1e-9; }).sort(function (a, b) { return a.price - b.price; });
      anchor = fits[0] || null;
    }
    if (!anchor) {
      var cheap = pool.slice().sort(function (a, b) { return a.price - b.price; })[0];
      return { items: [], total: 0, cheapest: cheap ? cheap.price : null };
    }
    if (hasPref && !anchorFromPref && preferredPool.length) usedFallback = true;

    var items = [{ handle: anchor.handle, title: anchor.title, price: anchor.price, type: anchor.type, qty: 1 }];
    var used = {}; used[anchor.handle] = 1;
    var remaining = round2(budget - anchor.price);
    var preferredSpent = anchorFromPref ? anchor.price : 0;
    var preferredCap = budget * PREF_SHARE;
    var rest = byPriceDesc.filter(function (p) { return p.handle !== anchor.handle; });
    var restPref = byPriceDescPref.filter(function (p) { return p.handle !== anchor.handle; });
    var boost = false;
    /* in de vulronde mag elke regel tot een gelijk deel van het budget oplopen (minstens LIM.manual): zo vult ook een
       smalle keuze (2 soorten packs) een groot budget, in plaats van te stoppen op 10 stuks per regel */
    function maxQtyFor(p) { return boost ? Math.min(QTY_CAP, Math.max(LIM.manual, Math.ceil(budget / Math.max(1, items.length) / Math.max(.01, p.price)))) : (p.type === 'pack' ? LIM.pack : LIM.box); }
    function rowFor(handle) {
      for (var k = 0; k < items.length; k++) { if (items[k].handle === handle) return items[k]; }
      return null;
    }
    function tryAdd(p, fromPref) {
      var already = used[p.handle] || 0;
      if (already >= maxQtyFor(p)) return false;
      if (p.price > remaining + 1e-9) return false;
      if (!already && items.length >= rowsMax) return false;
      used[p.handle] = already + 1;
      remaining = round2(remaining - p.price);
      if (fromPref) preferredSpent = round2(preferredSpent + p.price);
      var row = rowFor(p.handle);
      if (row) row.qty++; else items.push({ handle: p.handle, title: p.title, price: p.price, type: p.type, qty: 1 });
      return true;
    }

    var guard = 0;
    while (items.length < rowsMax && guard < 500) {
      guard++;
      var added = false;
      /* zolang het aandeel van het gekozen type onder de kaap blijft (ongeveer 80% van het
         budget) en er nog kandidaten van dat type zijn, vult die rij eerst aan; pas daarna
         (of zonder voorkeur) de rest, net als voorheen van duur naar goedkoop. */
      if (hasPref && preferredSpent < preferredCap - 1e-9) {
        for (var jp = 0; jp < restPref.length; jp++) { if (tryAdd(restPref[jp], true)) { added = true; break; } }
        if (added) continue;
      }
      for (var j = 0; j < rest.length; j++) { if (tryAdd(rest[j], false)) { added = true; break; } }
      if (!added) break;
    }
    var byPriceAsc = rest.slice().sort(function (a, b) { return a.price - b.price; });
    guard = 0;
    while (guard < 500) {
      guard++;
      var addedTop = false;
      for (var m = 0; m < byPriceAsc.length; m++) { if (tryAdd(byPriceAsc[m], false)) { addedTop = true; break; } }
      if (!addedTop) break;
    }
    /* groot budget (eigen bedrag tot 2000, eigenaar 5 okt: "selecteert maar tot 1000"): met 1 per doos, 6 per pack en
       8 regels zat het mandje vol voor het budget op was. Blijft er meer dan 5% over, dan mag elk product verder oplopen
       tot MANUAL_QTY_MAX, beurtelings van duur naar goedkoop (1 extra per product per ronde), zodat het gespreid blijft. */
    if (remaining > budget * 0.05) {
      boost = true;
      guard = 0;
      while (guard < QTY_CAP + 5) {
        guard++;
        var addedRound = false;
        for (var q = 0; q < byPriceDesc.length; q++) { if (tryAdd(byPriceDesc[q], false)) addedRound = true; }
        if (!addedRound) break;
      }
    }

    var total = 0;
    items.forEach(function (it) { total = round2(total + it.price * it.qty); });
    var result = { items: items, total: total };
    if (hasPref) result.prefFallback = usedFallback;
    return result;
  }
  function basketSignature(items) {
    return items.map(function (it) { return it.handle + ':' + it.qty; }).sort().join('|');
  }
  function handleSet(items) {
    var s = {}; items.forEach(function (it) { s[it.handle] = true; }); return s;
  }
  function sameHandleSet(itemsA, itemsB) {
    var a = handleSet(itemsA), b = handleSet(itemsB);
    var ak = Object.keys(a), bk = Object.keys(b);
    if (ak.length !== bk.length) return false;
    for (var i = 0; i < ak.length; i++) { if (!b[ak[i]]) return false; }
    return true;
  }
  /* het laagste bedrag (naar boven afgerond op een hele euro) waarmee deze franchise iets
     oplevert: gebruikt voor "Zet budget op" in de lege stand */
  function cheapestInFranchise(products, franchiseKey) {
    var pool = (products || []).filter(function (p) {
      return p && p.av !== false && p.type !== 'acc' && productMatchesFranchise(p, franchiseKey);
    });
    if (!pool.length) return null;
    var min = pool.reduce(function (m, p) { return p.price < m ? p.price : m; }, Infinity);
    return Math.ceil(min);
  }
  function findProduct(ctx, handle) {
    var list = (ctx && ctx.products) || [];
    for (var i = 0; i < list.length; i++) { if (list[i] && list[i].handle === handle) return list[i]; }
    return null;
  }

  /* ================= UI ================= */
  /* MAX is enkel een vangnet tegen onzin (7 cijfers): er is geen bovengrens voor de klant. De schuif loopt logaritmisch
     tot SMAX (laatste stap "10.000+"), daarboven typ je gewoon. */
  var MIN = 10, MAX = 9999999, SMAX = 10000, NARROW = 760, FIT_GAP = 28, GAP = 12;
  var CHIPS = [25, 50, 100, 250, 500, 1000];
  /* geheel getal met duizendtalscheiding volgens de taal van de pagina */
  function fmtInt(n, lang) { var sep = lang === 'en' ? ',' : lang === 'fr' ? '\u202f' : '.'; return String(Math.round(n || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  var FRS = [{ k: 'mix', c: 'all' }, { k: 'pokemon', c: 'pk' }, { k: 'one_piece', c: 'op' }, { k: '', c: 'tcg' }];
  function frCss(k) { for (var i = 0; i < FRS.length; i++) if (FRS[i].k === k) return FRS[i].c; return 'all'; }

  var SV = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
  var ICON = {
    minus: '<svg ' + SV + ' stroke-width="2"><path d="M6 12h12"/></svg>',
    plus: '<svg ' + SV + ' stroke-width="2"><path d="M6 12h12M12 6v12"/></svg>',
    swap: '<svg ' + SV + ' stroke-width="1.8"><path d="M19.5 10A7.5 7.5 0 0 0 6 6.6L4.5 8"/><path d="M4.5 4v4h4"/><path d="M4.5 14A7.5 7.5 0 0 0 18 17.4l1.5-1.4"/><path d="M19.5 20v-4h-4"/></svg>',
    x: '<svg ' + SV + ' stroke-width="1.6"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    check: '<svg ' + SV + ' stroke-width="2.4"><path d="M5 12.5l4.2 4.2L19 7"/></svg>',
    tick: '<svg ' + SV + ' stroke-width="3"><path d="M6.5 12.5l3.6 3.6 7.4-8"/></svg>',
    spin: '<svg class="rli-spin" ' + SV + ' stroke-width="1.8"><path d="M20 11a8 8 0 0 0-14.3-4.9L4 8"/><path d="M4 3.5V8h4.5"/><path d="M4 13a8 8 0 0 0 14.3 4.9L20 16"/><path d="M20 20.5V16h-4.5"/></svg>',
    prev: '<svg ' + SV + ' stroke-width="2"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg ' + SV + ' stroke-width="2"><path d="M9 5l7 7-7 7"/></svg>',
    down: '<svg ' + SV + ' stroke-width="2"><path d="M12 5v14M6 13l6 6 6-6"/></svg>',
    ok: '<svg ' + SV + ' stroke-width="2.4"><circle cx="12" cy="12" r="10"/><path d="M7.5 12.3l3 3 6-6.3"/></svg>',
    info: '<svg ' + SV + ' stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 11v6"/><circle cx="12" cy="7.6" r=".6" fill="currentColor"/></svg>'
  };

  /* klein motief per franchise, getekend uit het achtergrondpatroon van die franchise (zelfde lijnstijl) */
  var MOTIF = {
    all: '<svg ' + SV + ' stroke-width="1.6"><rect x="4" y="4.5" width="9.5" height="13.5" rx="1.8" transform="rotate(-9 8.75 11.25)"/><rect x="10.5" y="6" width="9.5" height="13.5" rx="1.8" transform="rotate(8 15.25 12.75)"/></svg>',
    pk: '<svg ' + SV + ' stroke-width="1.6"><path d="M13.5 2.5L6 13.5h5.2l-2 8 8.8-11.6h-5.3z"/></svg>',
    op: '<svg ' + SV + ' stroke-width="1.6"><circle cx="12" cy="4.8" r="2.2"/><path d="M12 7v14M7.5 10.5h9M4.8 15.5q7.2 9.5 14.4 0"/></svg>',
    tcg: '<svg ' + SV + ' stroke-width="1.6"><path d="M4 9.5l4-5h8l4 5-8 11z"/><path d="M4 9.5h16M12 20.5l-4-11M12 20.5l4-11"/></svg>'
  };

  function addBtnHTML(t, cls) {
    return '<button type="button" class="rli-btn rli-btn-pri ' + (cls || '') + '" data-rli-add><span class="rli-lmain">' + ICON.plus + '<span>' + esc(t.addAll) + '</span></span>' +
      '<span class="rli-ldone">' + ICON.check + esc(t.added) + '</span></button>';
  }
  function confirmHTML(t) {
    return '<div class="rli-confirm" data-rli-confirm hidden><span class="rli-cline" data-rli-cline></span>' +
      '<span class="rli-clinks"><button type="button" class="rli-link" data-rli-cart>' + esc(t.confirmCart) + '</button>' +
      '<button type="button" class="rli-link" data-rli-undo>' + esc(t.confirmUndo) + '</button></span></div>';
  }
  /* eerlijke melding als het voorstel ver onder het budget blijft omdat er binnen de keuzes niet meer is (paintTotals) */
  function noteHTML(live) { return '<p class="rli-note" data-rli-note' + (live ? ' role="status"' : '') + ' hidden></p>'; }
  function rerollBtnHTML(t) {
    return '<button type="button" class="rli-btn rli-btn-sec" data-rli-reroll>' + ICON.spin + '<span data-rli-rlbl>' + esc(t.reroll) + '</span></button>';
  }

  /* ---------------- linkerkolom: drie richtingen (?links=a|b|c, eigenaar 8 okt) ----------------
     Alle drie tekenen dezelfde bedieningselementen met dezelfde data-attributen (.rli-tab, [data-rli-input],
     [data-rli-range], [data-rli-num], .rli-chip, [data-rli-types], [data-rli-style]), dus dezelfde staat en dezelfde
     functies (wireTabs, wireBudget, wirePrefs); enkel de schikking en de vormtaal verschillen.
     A "Compact paneel": smalle segmentrij, budget op een regel (cijfer links, schuif en snelkeuzes rechts), voorkeur.
     B "Zinbouwer": een zin met vier klikbare pillen, elk met een compacte keuzelaag (wirePops).
     C "Bedieningsdek": een wit blok met fijne scheidingslijnen: ronde franchiseknoppen, cijfer met min en plus, chips. */
  var LINKS_VALS = ['a', 'b', 'c'], LINKS_KEY = 'cw-riplab-links';
  /* standaard C (eigenaar 8 okt, na het vergelijken van de drie); A en B blijven via de schakelaar */
  var LINKS = { v: 'c', sw: false };
  function tabsHTML(t) {
    return '<div class="rli-tabs" role="tablist" aria-label="' + esc(t.frAria) + '">' + FRS.map(function (f, i) {
      var lbl = f.c === 'tcg' ? esc(t.frOther[0]) + '<span class="rli-long">' + esc(t.frOther[1]) + '</span>' : esc(t.fr[f.k]);
      return '<button type="button" class="rli-tab" role="tab" data-f="' + f.k + '" data-c="' + f.c + '" aria-selected="' + (i ? 'false' : 'true') + '" tabindex="' + (i ? '-1' : '0') + '">' +
        '<span class="rli-tmot">' + MOTIF[f.c] + '<span class="rli-tok" aria-hidden="true">' + ICON.check + '</span></span><span class="rli-tlbl">' + lbl + '</span></button>';
    }).join('') + '</div>' +
      /* verborgen doorgeefknoppen voor het keuzescherm (app.js chooseApplyFranchise klikt .cws-seg[data-group="franchise3"]
         button[data-franchise3]); zonder de klasse cws-seg-franchise3, dus de Clean-laag ziet ze niet */
      '<div class="cws-seg" data-group="franchise3" style="display:none" aria-hidden="true">' + FRS.map(function (f) {
        return '<button type="button" tabindex="-1" data-franchise3="' + f.k + '"></button>';
      }).join('') + '</div>';
  }
  function numHTML(t, steps) {
    var n = '<div class="rli-numwrap"><label class="rli-num" data-rli-num title="' + esc(t.numTitle) + '">' +
      '<span class="rli-eur" aria-hidden="true">€</span><input data-rli-input type="text" inputmode="numeric" autocomplete="off" value="75" aria-label="' + esc(t.numAria) + '"></label></div>';
    if (steps) n = '<button type="button" class="rli-bstep" data-rli-bstep="-1" aria-label="' + esc(t.bMinus) + '" title="' + esc(t.bMinus) + '">' + ICON.minus + '</button>' + n +
      '<button type="button" class="rli-bstep" data-rli-bstep="1" aria-label="' + esc(t.bPlus) + '" title="' + esc(t.bPlus) + '">' + ICON.plus + '</button>';
    return n + '<span class="rli-measure" data-rli-measure aria-hidden="true"></span>';
  }
  function sliderHTML(t, lang, textChips) {
    return '<div class="rli-slider"><input data-rli-range type="range" min="0" max="1000" step="1" aria-label="' + esc(t.rangeAria) + '">' +
      '<span class="rli-rtop" data-rli-rtop aria-hidden="true">' + esc(t.rangeTop) + '</span></div>' +
      '<div class="rli-chips' + (textChips ? ' rli-tchips' : '') + '" role="group" aria-label="' + esc(t.chipsAria) + '">' + CHIPS.map(function (v) {
        return '<button type="button" class="rli-chip" data-v="' + v + '" aria-pressed="false">' + fmtInt(v, lang) + '</button>';
      }).join('') + '</div>';
  }
  /* soort (meervoudige chips, gevuld door paintPrefs) en samenstelling; eigen opslag cws-prefs-i2c-v1 */
  function typesHTML(t) { return '<div class="rli-types" role="group" aria-label="' + esc(t.typeAria) + '" data-rli-types></div>'; }
  function styleHTML(t) {
    return '<div class="rli-stylew"><div class="rli-style" role="group" aria-label="' + esc(t.styleAria) + '">' + STYLE_VALS.map(function (v) {
      return '<button type="button" class="rli-sbtn" data-rli-style="' + v + '" aria-pressed="' + (v === 'mixed') + '">' + esc(t.style[v]) + '</button>';
    }).join('') + '</div></div>';
  }
  function lswHTML(t, v) {
    if (!LINKS.sw) return '';
    return '<div class="rli-lsw" role="group" aria-label="' + esc(t.lsw) + '">' + LINKS_VALS.map(function (x) {
      return '<button type="button" data-rli-links="' + x + '" aria-pressed="' + (x === v) + '" title="' + esc(t.lnames[x]) + '" aria-label="' + esc(t.lsw + ': ' + t.lnames[x]) + '">' + x.toUpperCase() + '</button>';
    }).join('') + '</div>';
  }
  function h1HTML(t, cls) { return '<h2 class="rli-h1' + (cls || '') + '"><span>' + esc(t.h1a) + '</span> <span>' + esc(t.h1b) + '</span></h2>'; }
  function leadHTML(t) { return '<p class="rli-lead">' + esc(t.lead) + '</p>'; }
  function sh(t, k) { return '<h3 class="rli-sh">' + esc(t[k]) + '</h3>'; }
  function pillHTML(k, label) {
    return '<button type="button" class="rli-pill rli-pill-' + k + '" data-rli-pop="' + k + '" aria-haspopup="dialog" aria-expanded="false" aria-controls="" aria-label="' + esc(label) + '">' +
      '<span class="rli-pv" data-rli-pv="' + k + '"></span><svg class="rli-chev" ' + SV + ' stroke-width="2.2"><path d="M7 10l5 5 5-5"/></svg></button>';
  }
  function popHTML(k, title, inner) {
    return '<div class="rli-pop rli-pop-' + k + '" data-rli-popbox="' + k + '" role="dialog" aria-label="' + esc(title) + '" hidden><p class="rli-ptitle">' + esc(title) + '</p>' + inner + '</div>';
  }
  function ctrlHTML(ctx, t, v) {
    var o = '<div class="rli-ctrl rli-l' + v + '">';
    if (v === 'b') {
      /* de zin is de titel; de gewone titel blijft voor schermlezers */
      o += '<div class="rli-intro">' + lswHTML(t, v) + h1HTML(t, ' rli-sr') +
        '<p class="rli-sent"><span class="rli-sw">' + esc(t.sA) + '</span> ' + pillHTML('fr', t.stepFr) +
        ' <span class="rli-sw">' + esc(t.sB) + '</span> ' + pillHTML('bud', t.stepBud) + '<span class="rli-sw">,</span> ' +
        '<span class="rli-sw" data-rli-svooral>' + esc(t.sC) + ' </span>' + pillHTML('types', t.stepPref) + '<span class="rli-sw">,</span> ' +
        pillHTML('style', t.popStyle) + '<span class="rli-sw">' + esc(t.sEnd) + '</span></p>' +
        '<p class="rli-shint">' + esc(t.sHint) + '</p></div>';
      o += '<div class="rli-body">' +
        popHTML('fr', t.stepFr, tabsHTML(t)) +
        popHTML('bud', t.stepBud, '<div class="rli-budget">' + numHTML(t) + sliderHTML(t, ctx.lang, false) + '</div>') +
        popHTML('types', t.stepPref, typesHTML(t)) +
        popHTML('style', t.popStyle, styleHTML(t)) + '</div>';
    } else if (v === 'c') {
      o += '<div class="rli-intro">' + lswHTML(t, v) + h1HTML(t) + leadHTML(t) + '</div>';
      o += '<div class="rli-body rli-dek">' +
        '<div class="rli-dz rli-fr">' + sh(t, 'stepFr') + tabsHTML(t) + '</div>' +
        '<div class="rli-dz rli-budget">' + sh(t, 'stepBud') + '<div class="rli-brow">' + numHTML(t, true) + '</div>' + sliderHTML(t, ctx.lang, true) + '</div>' +
        '<div class="rli-dz rli-pref">' + sh(t, 'stepPref') + typesHTML(t) + styleHTML(t) + '</div></div>';
    } else {
      o += '<div class="rli-intro">' + lswHTML(t, v) + h1HTML(t) + leadHTML(t) + '</div>';
      o += '<div class="rli-body">' +
        '<div class="rli-blk rli-fr">' + sh(t, 'stepFr') + tabsHTML(t) + '</div>' +
        '<div class="rli-blk rli-budget">' + sh(t, 'stepBud') + '<div class="rli-brow">' + numHTML(t) + '<div class="rli-bside">' + sliderHTML(t, ctx.lang, true) + '</div></div></div>' +
        '<div class="rli-blk rli-pref">' + sh(t, 'stepPref') + '<div class="rli-prow">' + typesHTML(t) + styleHTML(t) + '</div></div></div>';
    }
    return o + '</div>';
  }

  function html(ctx) {
    var t = strFor(ctx.lang);
    var o = '<div class="rli" data-fr="all" data-links="' + LINKS.v + '" data-lang="' + esc(ctx.lang || 'nl') + '">';
    /* de Clean-laag leest de begroeting uit de budgetkaart (.cws-eyebrow-greet): onzichtbaar meegeven */
    o += '<span class="cws-eyebrow-greet" hidden>' + esc(t[greetingKey()] + (ctx.name ? ', ' + ctx.name : '')) + '</span>';
    o += '<div class="rli-scroll" data-cws-stack data-rli-scroll><div class="rli-content">';
    /* achtergrond: de vier franchiselagen, daarboven de golf en een vaste pool motieven voor de wereldovergang (worldFx) */
    o += '<div class="rli-bgs" aria-hidden="true"><div class="rli-bgls">' + FRS.map(function (f, i) {
      return '<div class="rli-bgl' + (i ? '' : ' rli-on') + '" data-l="' + f.c + '"' + (i ? '' : ' style="z-index:1"') + '><i class="rli-bb"></i><i class="rli-bv"></i></div>';
    }).join('') + '</div><i class="rli-wave"></i><div class="rli-mots">' + new Array(MOT_POOL + 1).join('<i class="rli-mot"></i>') + '</div></div>';

    /* ---- app-vlak: precies de hoogte van de scene ---- */
    o += '<section class="rli-app" aria-label="' + esc(t.appAria) + '">';
    o += ctrlHTML(ctx, t, LINKS.v);

    /* de kop van het paneel staat erboven, op dezelfde rij als de titel links: zo beginnen het bedieningsblok en het
       paneel op dezelfde hoogte en lopen ze allebei door tot de onderkant van het kader */
    o += '<header class="rli-phead"><h3 class="rli-h2">' + esc(t.h2) + ' <b data-rli-count>0</b></h3><span class="rli-psub" data-rli-psub></span></header>';
    o += '<section class="rli-panel" aria-label="' + esc(t.panelAria) + '">';
    /* de selectie als raster: tot 2 rijen van 4 gelijke kaarten (layoutDeck); meer dan er passen: per pagina, met
       pijlen opzij en stipjes eronder (wirePager) */
    o += '<div class="rli-deckwrap"><div class="rli-deck" data-rli-deck role="list" aria-label="' + esc(t.deckAria) + '"></div>' +
      '<div class="rli-pager" data-rli-pager hidden>' +
      '<button type="button" class="rli-snav rli-sprev" data-rli-sprev aria-label="' + esc(t.stripPrev) + '" title="' + esc(t.stripPrev) + '">' + ICON.prev + '</button>' +
      '<div class="rli-pdots" data-rli-pdots role="group" aria-label="' + esc(t.pagerAria) + '"></div>' +
      '<button type="button" class="rli-snav rli-snext" data-rli-snext aria-label="' + esc(t.stripNext) + '" title="' + esc(t.stripNext) + '">' + ICON.next + '</button>' +
      '<span class="rli-sr" data-rli-plive aria-live="polite"></span></div>' +
      '<div class="rli-empty" data-rli-empty></div></div>';
    o += '<div class="rli-car" role="region" aria-roledescription="carrousel" aria-label="' + esc(t.carAria) + '">' +
      '<div class="rli-track" data-rli-track></div>' +
      '<button type="button" class="rli-carnav rli-prev" data-rli-prev aria-label="' + esc(t.prev) + '">' + ICON.prev + '</button>' +
      '<button type="button" class="rli-carnav rli-next" data-rli-next aria-label="' + esc(t.next) + '">' + ICON.next + '</button>' +
      '<div class="rli-dots" data-rli-dots></div><div class="rli-carempty" data-rli-carempty></div></div>';
    /* voet: bedrag, balk en rest op een regel (scheelt een regel hoogte voor het raster), daaronder de knoppen */
    o += '<footer class="rli-foot"><div class="rli-fill"><span class="rli-left" data-rli-of></span>' +
      '<div class="rli-bar" aria-hidden="true"><i data-rli-bar></i></div><span class="rli-over" data-rli-over></span></div>' + noteHTML(true) + confirmHTML(t) +
      '<div class="rli-ctas">' + addBtnHTML(t) + rerollBtnHTML(t) + '</div></footer>';
    o += '</section>';
    o += '<button type="button" class="rli-hint" data-rli-hint><span>' + esc(t.moreHint) + '</span>' + ICON.down + '</button>';
    o += '</section>';

    /* ---- je volledige mandje (binnen de eigen scroll, met parallax) ---- */
    o += '<section class="rli-full" data-rli-full aria-label="' + esc(t.fullAria) + '"><div class="rli-fside">' +
      '<h2 class="rli-fh"><span>' + esc(t.fH1) + '</span> <span>' + esc(t.fH2) + ' <b data-rli-count>0</b></span></h2>' +
      '<p class="rli-fsub" data-rli-fsub>' + esc(t.fSubEmpty) + '</p>' +
      '<div class="rli-meter" aria-hidden="true"><div class="rli-tube"><i data-rli-tube></i></div><div class="rli-mside"><div class="rli-mmark" data-rli-mark></div></div></div>' +
      '<p class="rli-ftot" data-rli-of></p>' + noteHTML() + confirmHTML(t) +
      '<div class="rli-fctas">' + addBtnHTML(t) + rerollBtnHTML(t) + '</div></div>' +
      '<div class="rli-fmain"><ul class="rli-frows" data-rli-frows></ul><p class="rli-bempty" data-rli-fempty>' + esc(t.fEmpty) + '</p></div></section>';

    /* ---- gsm: vaste onderbalk (sticky onderaan de eigen scroll) ---- */
    o += '<div class="rli-mbar"><div class="rli-mtop"><span class="rli-left" data-rli-of></span><span class="rli-over" data-rli-over></span></div>' +
      '<div class="rli-bar" aria-hidden="true"><i data-rli-bar></i></div>' + noteHTML(true) + confirmHTML(t) +
      '<div class="rli-mrow">' + addBtnHTML(t, 'rli-btn-big') +
      '<button type="button" class="rli-ibbig" data-rli-reroll aria-label="' + esc(t.reroll) + '" title="' + esc(t.reroll) + '">' + ICON.spin + '</button></div></div>';

    o += '</div></div>';
    /* de toast brengt enkel meldingen (geen andere mix, geen alternatief): info-icoon, geen vinkje */
    o += '<div class="rli-toast" data-rli-toast role="status" aria-live="polite">' + ICON.info + '<span data-rli-toasttxt></span></div>';
    o += '</div>';
    return o;
  }

  /* ---------------- beeld per product: foto (meteen) met de 3D erover zodra die klaar is ---------------- */
  function fitArea(p) { return /Booster Pack|Blister|Double Pack/i.test((p && p.kind) || '') ? .5 : .72; }
  function fitRect(W, H, ar, area) {
    var h = Math.min(Math.sqrt(area * W * H / ar), (W * .9) / ar, H * .96);
    return { w: Math.round(h * ar), h: Math.round(h) };
  }
  /* zelfde maat en plek als het 3D-model van mountHero3D (oppervlakte 50% of 72%, onderaan met FIT_GAP lucht):
     zo kruisfadet de foto naar het model zonder sprong */
  function fitImg(img) {
    var box = img && img.parentNode; if (!box) return;
    var W = box.clientWidth, H = box.clientHeight - FIT_GAP, nw = img.naturalWidth, nh = img.naturalHeight;
    if (W < 8 || H < 8 || !nw || !nh) return;
    var r = fitRect(W, H, nw / nh, +img.getAttribute('data-area') || .5);
    img.style.width = r.w + 'px'; img.style.height = r.h + 'px';
  }
  function makeVis(S, h, eager) {
    var v = document.createElement('div');
    v.className = 'rli-vis';
    v.innerHTML = '<div class="rli-fb"><img alt="" decoding="async"' + (eager ? '' : ' loading="lazy"') + ' src="' + esc(S.ctx.img(h)) + '" data-area="' + fitArea(S.byH[h]) + '"></div><div class="rli-3d"></div>';
    var img = v.querySelector('img');
    img.addEventListener('load', function () { fitImg(img); v.classList.add('rli-fbok'); });
    img.addEventListener('error', function () { img.style.visibility = 'hidden'; });
    return v;
  }
  /* pas aanroepen als het vak in de DOM hangt: de pool zoekt dan meteen zijn root (de eigen scroll, data-cws-stack) */
  function attach3D(S, v, h) {
    /* kaart op een andere pagina van het raster: geen 3D (paintPage haakt hem aan zodra hij in beeld komt) */
    if (v.closest('.rli-off')) return;
    var img = v.querySelector('.rli-fb img');
    if (img && img.complete && img.naturalWidth) { fitImg(img); v.classList.add('rli-fbok'); }
    if (!S.ctx.mount3D || v._ctl) return;
    var d = v.querySelector('.rli-3d'), ctl = null;
    try { ctl = S.ctx.mount3D(d, h); } catch (e) { ctl = null; }
    if (!ctl) return;
    v._ctl = ctl;
    if (!d._rliOn) { d._rliOn = 1; d.addEventListener('cws-h3d', function (e) { v.classList.toggle('rli-3don', !!(e.detail && e.detail.on)); }); }
    if (d.classList.contains('cws-h3d-on')) v.classList.add('rli-3don');
  }
  /* na een wereldovergang (S.stagger): niet alle modellen in hetzelfde frame aanhaken (elk model laadt zijn texturen en
     de pool herverdeelt), maar een voor een met wat lucht ertussen; eerst de strook (prio 0), dan de lijst onderaan.
     Anders meteen. De foto staat er al, de 3D kruisfadet erover zodra hij klaar is. */
  var ATT_GAP = 160;
  function attachSoon(S, v, h, prio) {
    if (!v) return;
    if (!S.stagger) { attach3D(S, v, h); return; }
    var img = v.querySelector('.rli-fb img');
    if (img && img.complete && img.naturalWidth) { fitImg(img); v.classList.add('rli-fbok'); }
    attQueue(S, { v: v, h: h, p: prio });
  }
  function attQueue(S, it) {
    (S.attQ || (S.attQ = [])).push(it);
    S.attQ.sort(function (a, b) { return a.p - b.p; });
    /* pas na de overgang (FX_END): elk model kost bij het aanhaken een lang frame (texturen, shaders) */
    if (!S.attT) S.attT = setTimeout(function () { attPump(S); }, FX_END - FX_APPLY + 80);
  }
  /* een stap per tik: eerst de 3D van verdwenen producten vrijgeven (p -1), dan de nieuwe aanhaken */
  function attPump(S) {
    S.attT = 0;
    if (!getState(S.el)) return;
    var q = S.attQ || [], it;
    while ((it = q.shift()) && it.v && !it.v.isConnected) { /* weg intussen: overslaan */ }
    if (it && it.k) killVis(it.k); else if (it) attach3D(S, it.v, it.h);
    if (q.length) S.attT = setTimeout(function () { attPump(S); }, ATT_GAP);
  }
  function attFlush(S) { clearTimeout(S.attT); S.attT = 0; (S.attQ || []).forEach(function (it) { if (it.k) killVis(it.k); }); S.attQ = []; }
  function killVis(v) { if (v && v._ctl) { try { v._ctl.destroy(); } catch (e) { /* negeren */ } v._ctl = null; } }
  function killIn(node) { if (node) qsa('.rli-vis', node).forEach(killVis); }
  function refitAll(S) { qsa('.rli-fb img', S.el).forEach(fitImg); }

  /* ---------------- mount ---------------- */
  var STATES = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  function findRoot(root) {
    if (!root) return null;
    if (root.classList && root.classList.contains('rli')) return root;
    return root.querySelector ? root.querySelector('.rli') : null;
  }
  function setState(el, s) { if (STATES) STATES.set(el, s); else el.__rliState = s; }
  function getState(el) { return STATES ? STATES.get(el) : el.__rliState; }

  function mount(root, ctx) { mountWith(root, ctx, null); }
  function mountWith(root, ctx, carry) {
    var el = findRoot(root); if (!el) return;
    var t = strFor(ctx.lang), RM = prefersReduced();
    if (RM) el.classList.add('rli-rm');
    var host = el.parentNode; if (host && host.classList) host.classList.add('rli-host');
    var byH = {};
    (ctx.products || []).forEach(function (p) { if (p && p.handle) byH[p.handle] = p; });
    /* alle soorten die in het aanbod bestaan (niet afgekapt op 6: de chips tonen er 6 plus Meer) */
    var typeIds = TYPE_CAT_DEFS.map(function (d) { return d.id; }).filter(function (id) {
      return (ctx.products || []).some(function (p) { return p && p.av !== false && p.type !== 'acc' && classifyProduct(p) === id; });
    });
    var S = {
      ctx: ctx, t: t, el: el, RM: RM, byH: byH, links: el.getAttribute('data-links') || LINKS.v,
      sc: qs('[data-rli-scroll]', el), app: qs('.rli-app', el), full: qs('[data-rli-full]', el),
      budget: 75, franchise: 'mix', seed: loadSeed(), typePrefs: resolveTypePrefs(typeIds),
      lines: [], isManual: false, replaceSeen: {}, sel: null, hot: null, confirmed: null,
      mode: null, car: 0, shown: 0, timers: [], intervals: [], offs: [], ro: null, deckEls: new Map(),
      slideEls: new Map(), fullEls: new Map(), px: { ok: false, items: [], deck: [] }
    };
    /* een doel uit de oude Rip Lab (Sealed bewaren, Cadeau) zonder eigen soort of samenstelling heeft hier geen
       bediening: dan in het geheugen terug naar de standaard (CARDIX mengt), zodat Alles en Mix kloppen; niet opslaan */
    if (!S.typePrefs.types.length && S.typePrefs.style === 'mixed') { S.typePrefs.purpose = 'stream'; S.typePrefs.mode = 'auto'; }
    setState(el, S);
    function on(target, ev, fn, opt) { target.addEventListener(ev, fn, opt); S.offs.push(function () { target.removeEventListener(ev, fn, opt); }); }
    S.on = on;

    wireBudget(S); wireTabs(S); wireLines(S); wireButtons(S); wireCarousel(S); wireScroll(S); wirePrefs(S); wirePager(S); wireSway(S);
    wirePops(S); wireLinks(S);

    fitFrame(S);
    checkMode(S, true);
    if (carry) {
      /* wissel van richting (wireLinks): dezelfde keuzes en dezelfde selectie, niets opnieuw samenstellen */
      S.budget = carry.budget; S.franchise = carry.franchise; S.seed = carry.seed; S.typesOpen = carry.typesOpen;
      qsa('.rli-tab', el).forEach(function (x) { var on = (x.getAttribute('data-f') || '') === S.franchise; x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1; });
      paintFr(S, true);
      paintBudgetUI(S, S.budget);
      compose(S);
      S.lines = carry.lines; S.isManual = carry.isManual;
      render(S, 'carry');
    } else {
      paintBudgetUI(S, S.budget);
      compose(S);
      render(S, 'compose');
    }
    if (window.ResizeObserver) {
      S.ro = new ResizeObserver(function () {
        if (S.roRaf) return;
        S.roRaf = requestAnimationFrame(function () {
          S.roRaf = 0; if (!getState(el)) return;
          fitFrame(S); checkMode(S); sizeInput(S); layoutDeck(S); refitAll(S); goTo(S, S.car, false); pipClear(S); measureSoon(S);
          if (S.popOpen) popPlace(S, S.popOpen);
        });
      });
      S.ro.observe(el); S.ro.observe(S.app); S.ro.observe(S.full); var dkw = qs('.rli-deckwrap', el); if (dkw) S.ro.observe(dkw);
      /* .sc-in: klapt een kolom in of uit, dan schuift het Clean-kader mee en volgt het vlak meteen (fitFrame) */
      var scIn = host && host.parentNode; if (scIn && scIn.nodeType === 1) S.ro.observe(scIn);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (getState(el)) { sizeInput(S); layoutDeck(S); measureSoon(S); } });
    /* gsm: de PiP rechtsboven mag het budgetcijfer en de schuif niet bedekken; de PiP kan open of dicht gaan, dus
       af en toe (enkel zolang dit scherm in beeld is) opnieuw meten. Geen MutationObserver. */
    S.intervals.push(setInterval(function () { if (!document.hidden && isShown(S)) pipClear(S); }, 1500));
    /* Clean-kader volgen: de Clean-laag wisselt zijn klassen (Rip Lab, Jouw feed, ingeklapte kolom) zonder event */
    S.intervals.push(setInterval(function () { if (!document.hidden) { fitFrame(S); swayStart(S); } }, 500));
    on(window, 'resize', function () { fitFrame(S); });
    wireTabSwitch(S);
    pipClear(S);
  }
  function isShown(S) { var r = S.el.getBoundingClientRect(); return r.width > 0 && r.bottom > 0 && r.top < innerHeight; }

  /* ---------------- zelfde kader als Shop (desktop, Clean-laag, Rip Lab) ----------------
     Eigenaar 8 okt: "hou dezelfde witruimte van de kaders van Shop, wisselen van tab oogt vreemd". In Shop staan de witte
     kaarten in .gridview (#grid: left var(--lw), right var(--rw), top var(--hdr), bottom 0) met de scrollzone #gScroll
     (padding 22 px links en rechts, 28 px onder; boven 8 px + --col-t + 50 px - --hdr, met .cl-mx nog --mx erbij) en de
     filterkaart #gCard (margin-top 4 px, rand 1 px var(--line), radius 18 px, schaduw van .g-card). De filterkaart begint
     dus op --col-t + 62 px, 18 px lager dan het Clean-kader .cl-labframe (--hdr + 58 px), en 22 px (plus de scrollbalk
     rechts) binnen de randen waar het Clean-kader tegen --lw en --rw ligt.
     Daarom ligt de houder (.rli-fit) nu op die Shop-geometrie in plaats van op .cl-labframe, met dezelfde rand, radius en
     schaduw als #gCard; het Clean-kader zelf is dan onzichtbaar (html.rli-fitd, zie de css). Meten:
     - live in Shop (body.mode-grid): de echte rechthoek van #gCard ten opzichte van #grid, en de bovenkant zonder scroll;
       bewaard in SHOP (module-breed) en elke halve seconde ververst zolang Shop open is;
     - zolang Shop nog niet open was: dezelfde formules uit de css, met de live waarden van #grid (left, right, bottom),
       #gScroll (padding) en #gCard (rand, radius, schaduw) en een onzichtbare meetsonde voor --col-t en de scrollbalk.
     .cl-labframe blijft de poort: enkel als Clean het kader toont (desktop, Rip Lab) ligt de houder in deze geometrie.
     Horizontaal t.o.v. de containing block; verticaal t.o.v. de feed, zodat een scrollende feed de meting niet verstoort
     (een gesnapte scene staat bovenaan de feed). unmount haalt alles weer weg; de oude Rip Lab ziet dit nooit. */
  var FIT_VARS = ['--rli-fl', '--rli-ft', '--rli-fw', '--rli-fh'], LOOK_VARS = ['--rli-fr', '--rli-fb', '--rli-fc', '--rli-fs'];
  var SHOP = null, PROBE = null;
  function unfit(host) {
    try { document.documentElement.classList.remove('rli-fitd'); } catch (e) { /* negeren */ }
    if (!host || !host.classList || !host.classList.contains('rli-fit')) return;
    host.classList.remove('rli-fit');
    FIT_VARS.concat(LOOK_VARS).forEach(function (v) { host.style.removeProperty(v); });
  }
  function px(v) { return parseFloat(v) || 0; }
  /* klassen op html zonder onze eigen rli-fitd, gesorteerd: vergelijkbaar tussen Shop en Rip Lab */
  function htmlCls() { return String(document.documentElement.className || '').split(/\s+/).filter(function (c) { return c && c !== 'rli-fitd'; }).sort().join(' '); }
  function cardLook(card) {
    var cs = card ? getComputedStyle(card) : null;
    return cs ? { bw: px(cs.borderTopWidth), bc: cs.borderTopColor, rad: px(cs.borderTopLeftRadius), sh: cs.boxShadow || 'none' } : { bw: 1, bc: 'rgba(123,94,167,.16)', rad: 18, sh: 'none' };
  }
  /* Shop open: echte geometrie van de filterkaart, los van de scrollpositie */
  function measureShop() {
    var b = document.body;
    if (!b || !b.classList.contains('mode-grid')) return;
    var gv = document.getElementById('grid'), sc = document.getElementById('gScroll'), card = document.getElementById('gCard');
    if (!gv || !sc || !card) return;
    var G = gv.getBoundingClientRect(), r = card.getBoundingClientRect();
    if (r.width < 200 || G.width < 200) return;
    SHOP = { l: r.left - G.left, r: G.right - r.right, t: r.top + sc.scrollTop, look: cardLook(card), w: innerWidth, h: innerHeight, cls: htmlCls() };
  }
  /* meetsonde: --col-t (in px) en de breedte van een dunne scrollbalk zoals die van #gScroll */
  function probe() {
    if (!PROBE || !PROBE.isConnected) {
      PROBE = document.createElement('div');
      PROBE.setAttribute('aria-hidden', 'true');
      PROBE.style.cssText = 'position:fixed;left:0;top:0;width:60px;height:60px;overflow-y:scroll;scrollbar-width:thin;visibility:hidden;pointer-events:none;z-index:-1;margin-top:calc(var(--col-t, 70px) + 0px)';
      document.body.appendChild(PROBE);
    }
    return { colT: px(getComputedStyle(PROBE).marginTop), sb: Math.max(0, PROBE.offsetWidth - PROBE.clientWidth) };
  }
  /* de rechthoek (viewport) waar de filterkaart in Shop staat, en haar uitzicht */
  function shopRect() {
    var gv = document.getElementById('grid'), sc = document.getElementById('gScroll'), card = document.getElementById('gCard');
    var de = document.documentElement, W = de.clientWidth, H = de.clientHeight;
    var gs = gv ? getComputedStyle(gv) : null, ss = sc ? getComputedStyle(sc) : null;
    var gl = gs ? px(gs.left) : 0, gr = gs ? px(gs.right) : 0, gb = gs ? px(gs.bottom) : 0;
    var padB = ss ? px(ss.paddingBottom) : 28;
    var l, r, t, look;
    /* enkel de live meting gebruiken zolang venster en klassen op html dezelfde zijn (Clean-modus, ingeklapte kolom) */
    var ok = SHOP && SHOP.w === innerWidth && SHOP.h === innerHeight && SHOP.cls === htmlCls();
    if (ok) { l = SHOP.l; r = SHOP.r; t = SHOP.t; look = SHOP.look; }
    else {
      var pr = probe(), cm = card ? getComputedStyle(card) : null;
      l = (ss ? px(ss.paddingLeft) : 22) + (cm ? px(cm.marginLeft) : 0);
      r = (ss ? px(ss.paddingRight) : 22) + (cm ? px(cm.marginRight) : 0) + pr.sb;
      t = pr.colT + 62 + (document.body.classList.contains('cl-mx') ? px(getComputedStyle(document.body).getPropertyValue('--mx')) : 0);
      look = cardLook(card);
    }
    return { left: gl + l, right: W - gr - r, top: t, bottom: H - gb - padB, look: look };
  }
  function fitFrame(S) {
    var host = S.el.parentNode, b = document.body;
    if (!host || !host.classList || !b) return;
    measureShop();
    var fr = b.classList.contains('cl-lab') && !b.classList.contains('cl-off') && !b.classList.contains('mode-grid') ? document.querySelector('.cl-labframe') : null;
    var cs = fr ? getComputedStyle(fr) : null, F = fr ? fr.getBoundingClientRect() : null;
    var scene = host.closest ? host.closest('.scene') : null, feed = scene && scene.parentNode;
    if (!fr || cs.display === 'none' || F.width < 200 || F.height < 200 || !feed || !feed.getBoundingClientRect) { unfit(host); return; }
    var T = shopRect();
    if (T.right - T.left < 200 || T.bottom - T.top < 200) { unfit(host); return; }
    if (!host.classList.contains('rli-fit')) host.classList.add('rli-fit');
    document.documentElement.classList.add('rli-fitd');
    var op = host.offsetParent || scene, P = op.getBoundingClientRect(), Fd = feed.getBoundingClientRect();
    /* staat de scene bovenaan de feed (gesnapt, de Clean-laag vergrendelt de feed in Rip Lab): meten zoals hij staat;
       scrolt de feed nog: rekenen alsof hij al gesnapt is, zodat het vlak niet even verspringt */
    var Sr = scene ? scene.getBoundingClientRect() : P, fTop = Fd.top + feed.clientTop;
    var opTop = Math.abs(Sr.top - fTop) < 2 ? P.top - fTop : P.top - Sr.top;
    var vals = [T.left - P.left - op.clientLeft, T.top - fTop - opTop - op.clientTop, T.right - T.left, T.bottom - T.top]
      .map(function (x) { return Math.round(x * 10) / 10 + 'px'; });
    var lk = T.look, look = [lk.rad + 'px', lk.bw + 'px', lk.bc, lk.sh];
    FIT_VARS.forEach(function (v, i) { if (host.style.getPropertyValue(v) !== vals[i]) host.style.setProperty(v, vals[i]); });
    LOOK_VARS.forEach(function (v, i) { if (host.style.getPropertyValue(v) !== look[i]) host.style.setProperty(v, look[i]); });
  }

  /* ---------------- tabwissel: intrede bij het binnenkomen van Rip Lab ----------------
     De Clean-laag en de pagina wisselen de tab enkel met klassen op body (cl-lab, cl-ffeed, mode-grid), zonder event.
     Een MutationObserver op het class-attribuut van body LEEST enkel: hij schrijft niets op body terug (fitFrame zet
     stijlen op de houder en een klasse op html), dus hij triggert zichzelf nooit. Komt Rip Lab in beeld, dan eerst het
     kader op zijn plaats (nog in dezelfde microtask, voor het eerste beeld), dan .rli-enter: het kader schuift licht
     omhoog en vloeit in, titel, cijfer, keuzes, paneel en regels volgen gespreid (420 ms, enkel transform en opacity).
     Uittrede: niet mogelijk zonder de Clean-laag, die verbergt #feed (mode-grid) of de scene (cl-ffeed) in hetzelfde frame. */
  function inLab() { var b = document.body; return !!b && b.classList.contains('cl-lab') && !b.classList.contains('mode-grid') && !b.classList.contains('cl-off'); }
  function enter(S) {
    if (S.RM) return;
    var el = S.el;
    el.classList.remove('rli-enter'); void el.offsetWidth; el.classList.add('rli-enter');
    clearTimeout(S.enterT);
    S.enterT = setTimeout(function () { el.classList.remove('rli-enter'); if (getState(el)) measureSoon(S); }, 800);
  }
  function wireTabSwitch(S) {
    var was = inLab();
    var check = function () {
      if (!getState(S.el)) return;
      var now = inLab(); if (now === was) return;
      was = now; fitFrame(S);
      if (now) { enter(S); measureSoon(S); }
    };
    if (window.MutationObserver && document.body) {
      S.mo = new MutationObserver(check);
      S.mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    S.on(window, 'hashchange', function () { requestAnimationFrame(check); });
  }

  /* desktop (kader breed genoeg) of gsm-indeling; de stapel en de regels bestaan enkel op desktop, de carrousel enkel op gsm */
  function checkMode(S, first) {
    var m = S.el.clientWidth && S.el.clientWidth < NARROW ? 'm' : 'd';
    S.el.style.setProperty('--rli-h', (S.sc.clientHeight || 600) + 'px');
    if (m === S.mode) return;
    var had = S.mode != null; S.mode = m;
    S.el.classList.toggle('rli-m', m === 'm');
    if (!had && first) return;
    S.deckEls.forEach(function (c) { killIn(c); c.remove(); }); S.deckEls.clear();
    S.slideEls.forEach(function (s) { killIn(s); s.remove(); }); S.slideEls.clear();
    render(S, 'mode');
  }

  /* ---------------- samenstellen (composeFor uit start-scene.js) ---------------- */
  function cloneItems(items) {
    return (items || []).map(function (it) { var p = it; return { handle: p.handle, title: p.title, price: p.price, type: p.type, qty: p.qty, _slotKey: p._slotKey || p.handle }; });
  }
  function compose(S) {
    var res = composeFor(S.ctx, { budget: S.budget, franchise: S.franchise, typePrefs: S.typePrefs }, S.ctx.products || [], S.seed);
    /* vaste soortkeuze waarvan niets in het budget past: composeBasket zou terugvallen op andere soorten; hier niet,
       dan een leeg mandje met de melding en de knop om het budget op te trekken (renderEmpty) */
    S.typeMiss = typeMiss(S);
    S.lines = S.typeMiss ? [] : cloneItems(res.items); S.isManual = false; S.replaceSeen = {};
    S.gen = (S.gen || 0) + 1; S.hist = null; S.noOther = false;
    return res;
  }
  function typeMiss(S) {
    var eff = effectiveTypePrefs(S.ctx, { budget: S.budget, franchise: S.franchise, typePrefs: S.typePrefs });
    if (!eff.strict || !eff.types.length) return null;
    var min = Infinity;
    (S.ctx.products || []).forEach(function (p) {
      if (!p || p.av === false || p.type === 'acc' || !productMatchesFranchise(p, S.franchise)) return;
      if (eff.types.indexOf(classifyProduct(p)) !== -1 && p.price < min) min = p.price;
    });
    if (min <= S.budget + 1e-9) return null;
    /* naar boven afronden op hetzelfde raster als niceRound, zodat "Zet budget op" de soort echt binnenhaalt */
    var up = min === Infinity ? null : min < 100 ? Math.ceil(min) : min < 300 ? Math.ceil(min / 5) * 5 : Math.ceil(min / 10) * 10;
    return { min: up };
  }

  /* ---------------- soort en samenstelling (voorkeuren van de oude Rip Lab, zelfde opslag cws-prefs) ----------------
     Chips: Alles plus de soorten die voor de gekozen franchise en het budget echt producten hebben (een gekozen soort
     blijft altijd zichtbaar), 6 chips plus Meer. Een soort kiezen of een andere samenstelling = modus manual (vaste
     keuze, ook voor Andere selectie); Alles met Mix = auto (CARDIX mengt, zoals standaard). Elke wijziging bewaart en
     stelt meteen opnieuw samen. Het doel (stream, sealed, cadeau) heeft hier geen bediening en gaat terug naar stream. */
  var TYPE_SHOW = 6;
  function prefView(S) {
    var tp = S.typePrefs || defaultTypePrefs(), man = tp.mode === 'manual';
    return { types: man ? tp.types.slice() : [], style: man ? tp.style : 'mixed' };
  }
  function typeCounts(S) {
    var c = {};
    (S.ctx.products || []).forEach(function (p) {
      if (!p || p.av === false || p.type === 'acc' || p.price > S.budget + 1e-9 || !productMatchesFranchise(p, S.franchise)) return;
      var id = classifyProduct(p); if (id) c[id] = (c[id] || 0) + 1;
    });
    return c;
  }
  function paintPrefs(S) {
    var box = qs('[data-rli-types]', S.el); if (!box) return;
    var t = S.t, c = typeCounts(S), v = prefView(S);
    var ids = TYPE_CAT_DEFS.map(function (d) { return d.id; }).filter(function (id) { return c[id] || v.types.indexOf(id) !== -1; });
    var over = ids.length > TYPE_SHOW;
    var shown = over && !S.typesOpen ? ids.filter(function (id, i) { return i < TYPE_SHOW || v.types.indexOf(id) !== -1; }) : ids;
    var key = shown.join(',') + '|' + (over ? (S.typesOpen ? 'o' : 'c') : '') + '|' + shown.map(function (id) { return c[id] ? 1 : 0; }).join('');
    if (box.getAttribute('data-k') !== key) {
      var hadMore = !!(document.activeElement && document.activeElement.hasAttribute && document.activeElement.hasAttribute('data-rli-tmore') && box.contains(document.activeElement));
      box.setAttribute('data-k', key);
      var tick = '<span class="rli-pck" aria-hidden="true">' + ICON.tick + '</span>';
      box.innerHTML = '<button type="button" class="rli-pchip" data-rli-type="">' + esc(t.typeAll) + tick + '</button>' +
        shown.map(function (id) { return '<button type="button" class="rli-pchip' + (c[id] ? '' : ' rli-zero') + '" data-rli-type="' + id + '">' + esc(t.types[id] || id) + tick + '</button>'; }).join('') +
        (over ? '<button type="button" class="rli-pchip rli-pmore" data-rli-tmore aria-expanded="' + !!S.typesOpen + '">' + esc(S.typesOpen ? t.typeLess : t.typeMore) + '</button>' : '');
      if (hadMore) { var mb = qs('[data-rli-tmore]', box); if (mb) mb.focus(); }
    }
    qsa('[data-rli-type]', box).forEach(function (b) {
      var id = b.getAttribute('data-rli-type');
      b.setAttribute('aria-pressed', String(id ? v.types.indexOf(id) !== -1 : !v.types.length));
    });
    qsa('[data-rli-style]', S.el).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-rli-style') === v.style)); });
    paintSentence(S);
  }

  /* ---------------- zinbouwer (richting B): pillen en keuzelagen ----------------
     Elke pil is een knop met aria-expanded die zijn keuzelaag (role="dialog", niet modaal) opent onder de pil. Escape
     sluit en zet de focus terug op de pil; een klik buiten de laag en de pil sluit; de focus die de laag verlaat sluit.
     Franchise en samenstelling (een keuze) sluiten na een klik of Enter; soorten en budget blijven open. De pil van het
     budget kan je ook opzij slepen om het bedrag te schuiven, zoals het grote cijfer. */
  function typeWord(S, id) { var w = S.t.types[id] || id; return w === w.toUpperCase() ? w : w.toLowerCase(); }
  function paintSentence(S) {
    if (S.links !== 'b') return;
    var t = S.t, v = prefView(S), set = function (k, txt, lbl) {
      var pv = qs('[data-rli-pv="' + k + '"]', S.el); if (pv && pv.textContent !== txt) pv.textContent = txt;
      var p = qs('[data-rli-pop="' + k + '"]', S.el); if (p) p.setAttribute('aria-label', lbl + ': ' + txt);
    };
    set('fr', S.franchise === 'mix' ? t.sFr.mix : S.franchise ? t.sFr[S.franchise] : t.sFr.other, t.stepFr);
    var ty = v.types.map(function (id) { return typeWord(S, id); });
    set('types', !ty.length ? t.sTypesNone : ty.length <= 2 ? ty.join(t.sAnd) : ty.slice(0, 2).join(', ') + ' +' + (ty.length - 2), t.stepPref);
    var vo = qs('[data-rli-svooral]', S.el); if (vo) vo.hidden = !ty.length;
    set('style', t.sStyle[v.style] || t.sStyle.mixed, t.popStyle);
    paintBudPill(S, S.budget);
  }
  function paintBudPill(S, v) {
    if (S.links !== 'b') return;
    var pv = qs('[data-rli-pv="bud"]', S.el), txt = '€ ' + fmtInt(v, S.ctx.lang); if (!pv) return;
    if (pv.textContent !== txt) pv.textContent = txt;
    var p = qs('[data-rli-pop="bud"]', S.el); if (p) p.setAttribute('aria-label', S.t.stepBud + ': ' + txt);
  }
  function popClose(S, back) {
    var k = S.popOpen; if (!k) return;
    S.popOpen = null;
    var box = qs('[data-rli-popbox="' + k + '"]', S.el), pill = qs('[data-rli-pop="' + k + '"]', S.el);
    if (box) box.hidden = true;
    if (pill) { pill.setAttribute('aria-expanded', 'false'); if (back) try { pill.focus({ preventScroll: true }); } catch (e) { /* negeren */ } }
  }
  function popPlace(S, k) {
    var box = qs('[data-rli-popbox="' + k + '"]', S.el), pill = qs('[data-rli-pop="' + k + '"]', S.el), ctrl = qs('.rli-ctrl', S.el);
    if (!box || !pill || !ctrl) return;
    var cr = ctrl.getBoundingClientRect(), pr = pill.getBoundingClientRect(), bw = box.offsetWidth;
    box.style.left = Math.round(clamp(pr.left - cr.left - 6, 0, Math.max(0, cr.width - bw))) + 'px';
    box.style.top = Math.round(pr.bottom - cr.top + 8) + 'px';
  }
  function popOpen(S, k) {
    if (S.popOpen === k) return;
    popClose(S, false);
    var box = qs('[data-rli-popbox="' + k + '"]', S.el), pill = qs('[data-rli-pop="' + k + '"]', S.el); if (!box || !pill) return;
    S.popOpen = k; box.hidden = false; pill.setAttribute('aria-expanded', 'true');
    popPlace(S, k);
    if (k === 'bud') sizeInput(S);
    if (!S.RM && box.animate) box.animate([{ opacity: 0, transform: 'translateY(-6px) scale(.98)' }, { opacity: 1, transform: 'none' }], { duration: 220, easing: 'cubic-bezier(.22,1,.36,1)' });
    /* focus in de laag: de gekozen keuze, anders het eerste bedieningselement */
    var f = qs('.rli-tab[aria-selected="true"],[data-rli-style][aria-pressed="true"],[data-rli-input],[data-rli-type]', box) || qs('button,input', box);
    if (f) try { f.focus({ preventScroll: true }); if (f.hasAttribute('data-rli-input')) f.select(); } catch (e) { /* negeren */ }
  }
  function wirePops(S) {
    if (S.links !== 'b') return;
    var el = S.el, uid = 'rli' + Math.random().toString(36).slice(2, 8);
    qsa('[data-rli-pop]', el).forEach(function (p) {
      var k = p.getAttribute('data-rli-pop'), box = qs('[data-rli-popbox="' + k + '"]', el);
      if (box) { box.id = uid + '-' + k; p.setAttribute('aria-controls', box.id); }
    });
    /* de budgetpil: slepen schuift het bedrag, een tik opent de laag */
    var bp = qs('[data-rli-pop="bud"]', el), drag = null;
    S.on(bp, 'pointerdown', function (e) { if (e.button > 0 || e.pointerType !== 'mouse') return; drag = { x: e.clientX, v: S.budget, id: e.pointerId, moved: false }; });
    S.on(window, 'pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 6) { drag.moved = true; try { bp.setPointerCapture(e.pointerId); } catch (er) { /* negeren */ } }
      if (drag.moved) setBudget(S, drag.v * Math.exp(dx / 240), 'range');
    });
    var end = function (e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var was = drag.moved; drag = null;
      if (was) { var stop = function (ev) { ev.stopPropagation(); ev.preventDefault(); }; bp.addEventListener('click', stop, { capture: true, once: true }); setTimeout(function () { bp.removeEventListener('click', stop, { capture: true }); }, 0); }
    };
    S.on(window, 'pointerup', end); S.on(window, 'pointercancel', end);
    S.on(el, 'click', function (e) {
      var p = e.target.closest('[data-rli-pop]');
      if (p && el.contains(p)) { var k = p.getAttribute('data-rli-pop'); if (S.popOpen === k) popClose(S, false); else popOpen(S, k); return; }
      /* een keuze in een laag met een enkele keuze: kiezen en sluiten (met de muis; het toetsenbord via keydown) */
      if (e.detail > 0 && S.popOpen && (S.popOpen === 'fr' || S.popOpen === 'style') && e.target.closest('.rli-tab,[data-rli-style]') && e.target.closest('[data-rli-popbox]')) {
        requestAnimationFrame(function () { popClose(S, true); });
      }
    });
    S.on(el, 'keydown', function (e) {
      if (!S.popOpen) return;
      var box = qs('[data-rli-popbox="' + S.popOpen + '"]', el);
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); popClose(S, true); return; }
      if ((e.key === 'Enter' || e.key === ' ') && box && box.contains(e.target) && (S.popOpen === 'fr' || S.popOpen === 'style') && e.target.closest('.rli-tab,[data-rli-style]')) {
        setTimeout(function () { popClose(S, true); }, 0);
      }
    }, true);
    S.on(document, 'pointerdown', function (e) {
      if (!S.popOpen) return;
      var box = qs('[data-rli-popbox="' + S.popOpen + '"]', el), pill = qs('[data-rli-pop="' + S.popOpen + '"]', el);
      if ((box && box.contains(e.target)) || (pill && pill.contains(e.target))) return;
      popClose(S, false);
    }, true);
    S.on(el, 'focusout', function (e) {
      if (!S.popOpen || !e.relatedTarget) return;
      var box = qs('[data-rli-popbox="' + S.popOpen + '"]', el), pill = qs('[data-rli-pop="' + S.popOpen + '"]', el);
      if ((box && box.contains(e.relatedTarget)) || (pill && pill.contains(e.relatedTarget))) return;
      if (box && box.contains(e.target)) popClose(S, false);
    });
  }

  /* ---------------- keuzepil rechtsboven: richting A, B of C (enkel met ?riplab=nieuw, om te vergelijken) ----------------
     Zelfde element, nieuwe binnenkant: unmount, html() met de nieuwe richting, opnieuw monteren met dezelfde keuzes en
     dezelfde selectie (carry). Onthouden in sessionStorage (cw-riplab-links). */
  function wireLinks(S) {
    S.on(S.el, 'click', function (e) {
      var b = e.target.closest('[data-rli-links]'); if (!b || !S.el.contains(b)) return;
      var v = b.getAttribute('data-rli-links'); if (LINKS_VALS.indexOf(v) === -1 || v === S.links) return;
      setLinks(v);
      fxFlush(S); /* lopende wereldovergang eerst afronden, anders hoort S.lines nog bij de vorige franchise */
      var el = S.el, ctx = S.ctx, carry = { budget: S.budget, franchise: S.franchise, seed: S.seed, lines: cloneItems(S.lines), isManual: S.isManual, typesOpen: S.typesOpen };
      unmount(el);
      var tmp = document.createElement('div'); tmp.innerHTML = html(ctx);
      var fresh = tmp.firstElementChild;
      el.innerHTML = fresh.innerHTML;
      ['data-links', 'data-fr', 'data-lang'].forEach(function (a) { el.setAttribute(a, fresh.getAttribute(a)); });
      el.className = fresh.className;
      mountWith(el, ctx, carry);
      var nb = qs('[data-rli-links="' + v + '"]', el); if (nb) try { nb.focus({ preventScroll: true }); } catch (er) { /* negeren */ }
    });
  }
  function setLinks(v) {
    LINKS.v = v;
    try { sessionStorage.setItem(LINKS_KEY, v); } catch (e) { /* negeren */ }
    try { var u = new URL(location.href); if (u.searchParams.get('links') !== v) { u.searchParams.set('links', v); history.replaceState(history.state, '', u.pathname + u.search + u.hash); } } catch (e) { /* negeren */ }
  }
  function wirePrefs(S) {
    S.on(S.el, 'click', function (e) {
      var b = e.target.closest('[data-rli-type],[data-rli-style],[data-rli-tmore],[data-rli-alltypes],[data-rli-clearf]');
      if (!b || !S.el.contains(b)) return;
      if (b.hasAttribute('data-rli-tmore')) { S.typesOpen = !S.typesOpen; paintPrefs(S); return; }
      var v = prefView(S), types = v.types, style = v.style;
      if (b.hasAttribute('data-rli-type')) {
        var id = b.getAttribute('data-rli-type');
        if (!id) { if (!types.length && (S.typePrefs || {}).mode !== 'manual') return; types = []; }
        else { var i = types.indexOf(id); if (i === -1) types.push(id); else types.splice(i, 1); }
      } else if (b.hasAttribute('data-rli-alltypes')) { types = []; }
      else if (b.hasAttribute('data-rli-clearf')) { types = []; style = 'mixed'; }
      else { var sv = b.getAttribute('data-rli-style'); if (sv === style || STYLE_VALS.indexOf(sv) === -1) return; style = sv; }
      var tp = S.typePrefs || (S.typePrefs = defaultTypePrefs());
      tp.types = types; tp.style = style; tp.purpose = 'stream';
      tp.mode = types.length || style !== 'mixed' ? 'manual' : 'auto';
      saveTypePrefs(tp);
      changed(S); compose(S); render(S, 'compose');
      /* de knop in de melding verdwijnt: de focus naar de chip Alles, niet naar body */
      if (b.hasAttribute('data-rli-clearf')) { var al = qs('[data-rli-type=""]', S.el); if (al) try { al.focus({ preventScroll: true }); } catch (er) { /* negeren */ } }
    });
  }
  function sig(lines) { return lines.map(function (l) { return l.handle + ':' + l.qty; }).sort().join('|'); }
  function total(S) { return S.lines.reduce(function (s, l) { return round2(s + l.price * l.qty); }, 0); }
  function units(S) { return S.lines.reduce(function (s, l) { return s + l.qty; }, 0); }
  function idxOf(S, h) { for (var i = 0; i < S.lines.length; i++) if (S.lines[i].handle === h) return i; return -1; }
  function canPlus(S, l) { return l.qty < Math.min(QTY_CAP, Math.max(limitsFor(S.budget).manual, Math.ceil(S.budget / Math.max(.01, l.price)))) && total(S) + l.price <= S.budget + 1e-9; }
  function kindOf(S, h) { return kindLabel(S.ctx, h) || ''; }
  /* elke echte wijziging aan de selectie haalt de bevestiging na "Alles in mijn mandje" weg */
  function changed(S) { S.confirmed = null; clearTimeout(S.peekT); }

  /* ---------------- budget ---------------- */
  /* afronden voor de schuif en het slepen; getypte bedragen blijven exact (geheel getal) */
  function niceRound(v) { return v < 100 ? Math.round(v) : v < 300 ? Math.round(v / 5) * 5 : v < 1000 ? Math.round(v / 10) * 10 : v < 5000 ? Math.round(v / 50) * 50 : Math.round(v / 100) * 100; }
  function toPos(v) { return Math.round(Math.log(clamp(v, MIN, SMAX) / MIN) / Math.log(SMAX / MIN) * 1000); }
  function fromPos(p) { return MIN * Math.pow(SMAX / MIN, p / 1000); }
  /* breedte van het invoerveld op de tekst, en het cijfer kleiner zetten tot het (met euroteken) in de kolom past */
  function sizeInput(S) {
    var num = qs('[data-rli-num]', S.el), inp = qs('[data-rli-input]', S.el), ms = qs('[data-rli-measure]', S.el);
    if (!num || !inp || !ms) return;
    num.style.fontSize = '';
    var fs = parseFloat(getComputedStyle(num).fontSize) || 80, eu = qs('.rli-eur', num);
    ms.style.fontSize = fs + 'px';
    ms.textContent = inp.value || '0';
    var w = ms.getBoundingClientRect().width + 6, ew = eu ? eu.getBoundingClientRect().width : fs * .5;
    var wrap = num.parentNode, avail = wrap ? wrap.clientWidth - 4 : 0;
    if (avail > 40 && w + ew > avail) { var k = Math.max(.3, avail / (w + ew)); num.style.fontSize = (fs * k).toFixed(1) + 'px'; w *= k; }
    inp.style.width = w + 'px';
  }
  function paintBudgetUI(S, v, skipInput) {
    var inp = qs('[data-rli-input]', S.el), rg = qs('[data-rli-range]', S.el), top = qs('[data-rli-rtop]', S.el);
    /* in het veld (focus): kale cijfers om te typen; anders met duizendtalscheiding */
    if (!skipInput && inp) inp.value = document.activeElement === inp ? String(Math.round(v)) : fmtInt(v, S.ctx.lang);
    sizeInput(S);
    var pos = toPos(v);
    if (rg) {
      rg.value = pos; rg.style.setProperty('--p', (pos / 10) + '%');
      rg.setAttribute('aria-valuetext', Math.round(v) === SMAX ? '€ ' + S.t.rangeTop : eurInt(v));
    }
    if (top) top.classList.toggle('rli-show', v >= SMAX - 1e-9);
    qsa('.rli-chip', S.el).forEach(function (c) { c.setAttribute('aria-pressed', String(+c.getAttribute('data-v') === Math.round(S.budget))); });
    paintBudPill(S, v);
  }
  function tweenBudget(S, from, to) {
    if (S.RM) { paintBudgetUI(S, to); return; }
    var id = S.tweenId = (S.tweenId || 0) + 1, t0 = performance.now();
    (function step(now) {
      if (id !== S.tweenId || !getState(S.el)) return;
      var k = clamp((now - t0) / 520, 0, 1), e = 1 - Math.pow(1 - k, 3);
      paintBudgetUI(S, from + (to - from) * e);
      if (k < 1) requestAnimationFrame(step);
    })(t0);
  }
  function setBudget(S, v, how) {
    v = clamp(how === 'type' || how === 'force' ? Math.round(v) : niceRound(v), MIN, MAX);
    var old = S.budget;
    if (v === old && how !== 'force') { paintBudgetUI(S, v, how === 'type'); return; }
    S.budget = v;
    if (how === 'chip') tweenBudget(S, old, v); else { S.tweenId = (S.tweenId || 0) + 1; paintBudgetUI(S, v, how === 'type'); }
    if (v === old) return;
    if (!S.cRaf) S.cRaf = requestAnimationFrame(function () { S.cRaf = 0; if (!getState(S.el)) return; changed(S); compose(S); render(S, 'compose'); });
  }
  function budStep(b) { return b < 100 ? 5 : b < 300 ? 10 : b < 1000 ? 25 : b < 5000 ? 100 : 500; }
  function digitsOf(s) { return String(s || '').replace(/[^0-9]/g, '').slice(0, 7); }
  function wireBudget(S) {
    var on = S.on, el = S.el;
    var rg = qs('[data-rli-range]', el), inp = qs('[data-rli-input]', el), num = qs('[data-rli-num]', el);
    on(rg, 'input', function () { setBudget(S, fromPos(+rg.value), 'range'); });
    qsa('.rli-chip', el).forEach(function (c) { on(c, 'click', function () { setBudget(S, +c.getAttribute('data-v'), 'chip'); }); });
    /* richting C: min en plus naast het cijfer, zelfde stappen als pijl omhoog en omlaag in het veld */
    qsa('[data-rli-bstep]', el).forEach(function (c) { on(c, 'click', function () { setBudget(S, S.budget + (+c.getAttribute('data-rli-bstep')) * budStep(S.budget), 'force'); }); });
    on(inp, 'focus', function () { inp.value = String(S.budget); sizeInput(S); });
    on(inp, 'input', function () {
      var digits = digitsOf(inp.value);
      inp.value = digits; sizeInput(S);
      var n = +digits; if (n >= MIN) setBudget(S, n, 'type');
    });
    on(inp, 'blur', function () { setBudget(S, +digitsOf(inp.value) || S.budget, 'force'); });
    on(inp, 'keydown', function (e) {
      if (e.key === 'Enter') inp.blur();
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault();
        setBudget(S, S.budget + (e.key === 'ArrowUp' ? 1 : -1) * budStep(S.budget), 'type');
        inp.value = String(S.budget); sizeInput(S);
      }
    });
    /* sleep op het grote cijfer om het budget te schuiven (zonder bovengrens), tik om te typen */
    var start = null;
    on(num, 'pointerdown', function (e) {
      if (document.activeElement === inp || e.button > 0) return;
      e.preventDefault();
      start = { x: e.clientX, v: S.budget, drag: false, id: e.pointerId };
    });
    on(window, 'pointermove', function (e) {
      if (!start || e.pointerId !== start.id) return;
      var dx = e.clientX - start.x;
      if (!start.drag && Math.abs(dx) > 6) { start.drag = true; try { num.setPointerCapture(e.pointerId); } catch (er) { /* negeren */ } }
      if (start.drag) setBudget(S, start.v * Math.exp(dx / 240), 'range');
    });
    on(window, 'pointerup', function (e) {
      if (!start || e.pointerId !== start.id) return;
      var was = start.drag; start = null;
      if (!was) { inp.focus(); inp.select(); }
    });
    on(window, 'pointercancel', function () { start = null; });
  }

  /* ---------------- franchise: tabs, achtergrond en wereldovergang ---------------- */
  function wireTabs(S) {
    var tabs = qsa('.rli-tab', S.el);
    tabs.forEach(function (tb, i) {
      S.on(tb, 'click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', String(x === tb)); x.tabIndex = x === tb ? 0 : -1; });
        var f = tb.getAttribute('data-f') || '';
        if (f === S.franchise) return;
        S.franchise = f;
        changed(S);
        paintSentence(S);
        /* zinbouwer: de golf vertrekt vanuit de pil (de keuzelaag gaat dicht), anders vanuit de tegel */
        var org = S.links === 'b' ? qs('[data-rli-pop="fr"]', S.el) || tb : tb;
        /* het mandje pas opnieuw samenstellen als de golf het kader bedekt (worldFx roept apply dan aan) */
        worldFx(S, org, frCss(f), function () { compose(S); render(S, 'world'); });
        prefetchFor(S, f);
      });
      S.on(tb, 'keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault(); e.stopPropagation();
        var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        n.focus(); n.click();
      });
    });
  }
  /* tijdens de golf alvast de foto's van de nieuwe selectie laden en decoderen (img.decode loopt buiten de hoofdthread),
     zodat het hertekenen na de piek geen lang frame met beelddecodering geeft; zelfde seed, dus dezelfde producten */
  function prefetchFor(S, f) {
    clearTimeout(S.preT);
    S.preT = setTimeout(function () {
      if (!getState(S.el) || S.franchise !== f) return;
      var res; try { res = composeFor(S.ctx, { budget: S.budget, franchise: f, typePrefs: S.typePrefs }, S.ctx.products || [], S.seed); } catch (e) { return; }
      (res.items || []).slice(0, 8).forEach(function (it) {
        if (S.deckEls.has(it.handle)) return;
        var im = new Image(); im.decoding = 'async'; im.src = S.ctx.img(it.handle);
        if (im.decode) im.decode().catch(function () { /* negeren */ });
      });
    }, 40);
  }
  /* vier gestapelde lagen; de nieuwe komt bovenop. Gewoon: ze vloeit in (500 ms, enkel opacity). Tijdens een
     wereldovergang (S.fxHold) wachten de wissel en de kleuren van de nieuwe franchise (data-fr) op het moment dat de
     golf alles bedekt; dan meteen, zonder overvloeier. */
  function paintFr(S, instant) {
    if (S.fxHold && !instant) return;
    var k = frCss(S.franchise), cur = null, ls = qsa('.rli-bgl', S.el);
    if (S.el.getAttribute('data-fr') !== k) S.el.setAttribute('data-fr', k);
    ls.forEach(function (l) { if (l.getAttribute('data-l') === k) cur = l; });
    S.bgZ = S.bgZ || 1;
    if (!cur || (cur.classList.contains('rli-on') && +cur.style.zIndex === S.bgZ)) return;
    if (cur.classList.contains('rli-on') || instant) { cur.style.transition = 'none'; cur.classList.remove('rli-on'); void cur.offsetWidth; }
    cur.style.zIndex = ++S.bgZ;
    cur.classList.add('rli-on');
    if (instant) { void cur.offsetWidth; cur.style.transition = ''; } else cur.style.transition = '';
    clearTimeout(S.bgT);
    var off = function () { ls.forEach(function (l) { if (l !== cur) l.classList.remove('rli-on'); }); };
    if (instant || S.RM) off(); else S.bgT = setTimeout(off, 560);
  }

  /* Wereldovergang bij het wisselen van franchise (eigenaar 8 okt: "alsof je echt in een Pokémon-wereld stapt"; daarna
     "iets te snel en niet vloeiend"), samen ongeveer 1250 ms met zachte easing (.22,1,.36,1), in drie lagen:
     1. golf (0 tot 700 ms): een cirkel in de kleur van de nieuwe wereld groeit vanuit de aangeklikte tegel (of pil)
        over het hele kader (transform: scale op een vast element, opacity enkel bij het begin). Op FX_SWAP (560 ms)
        bedekt hij alles: dan wisselen achtergrond en kleuren (paintFr instant) en vervaagt hij tot 1220 ms, zodat het
        patroon van de nieuwe wereld rustig verschijnt;
     2. motieven (vanaf 120 ms, gespreid met 22 ms per stuk): 16 motieven (gsm 8) vliegen uit de tegel, zakken met diepte
        (verder weg = kleiner, trager, lichter) naar rust en vervagen in het patroon;
     3. landing (vanaf 640 ms): de linkerkolom zakt heel even in en veert terug; de nieuwe producten komen gespreid binnen.
     Zwaar werk pas na de piek: apply() (samenstellen en de strook hertekenen) loopt op FX_APPLY, en de nieuwe 3D-modellen
     worden daarna een voor een aangehaakt (attachQueue), zodat er tijdens de golf geen lange frames vallen.
     will-change staat enkel tijdens de overgang op de golf en de motieven. Alles uit een vaste pool (.rli-wave en
     MOT_POOL x .rli-mot, gemaakt in html()); geen nieuwe elementen per klik. Een nieuwe klik breekt de lopende overgang
     af (fxStop: animaties en timers weg); enkel de laatste franchise wordt samengesteld. Reduced motion: geen overgang,
     meteen samenstellen met de gewone overvloeier van paintFr. */
  var MOT_POOL = 16, MOT_M = 8, FX_SWAP = 560, FX_APPLY = 600, FX_END = 1300;
  var WORLD = {
    all: { a: '#6a3fd1', in: '#d6c4fa', out: '#edeaf5' },
    pk: { a: '#2f5bc4', in: '#ffe27a', out: '#fff6d9' },
    op: { a: '#c2362b', in: '#ffbfac', out: '#fdece8' },
    tcg: { a: '#5b3a96', in: '#cbb5ef', out: '#e7dff4' }
  };
  function svgm(inner) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + inner + '</svg>'; }
  /* zelf getekende motieven, zelfde lijnstijl als de achtergrondpatronen; geen logo's of personages */
  var MOTS = {
    pk: [svgm('<path d="M13.5 2.5L6 13.5h5.2l-2 8 8.8-11.6h-5.3z"/>'),
      svgm('<circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h5.6M14.9 12h5.6"/><circle cx="12" cy="12" r="2.6"/>'),
      svgm('<path d="M12 3q6.5 8 6.5 12a6.5 6.5 0 0 1-13 0q0-4 6.5-12z"/>')],
    op: [svgm('<path d="M2 10q2.5-3 5 0t5 0t5 0t5 0"/><path d="M2 15.5q2.5-3 5 0t5 0t5 0t5 0"/>'),
      svgm('<circle cx="12" cy="4.8" r="2.2"/><path d="M12 7v14M7.5 10.5h9M4.8 15.5q7.2 9.5 14.4 0"/>'),
      svgm('<circle cx="12" cy="12" r="8.5"/><path d="M12 3.5v17M3.5 12h17"/><path d="M12 7.5l1.8 4.5-1.8 4.5-1.8-4.5z"/>'),
      svgm('<path d="M6.5 11a5.5 5.5 0 0 1 11 0c0 2-1 3.2-2.2 3.9v2.6H8.7v-2.6C7.5 14.2 6.5 13 6.5 11z"/><circle cx="9.8" cy="11" r="1.1"/><circle cx="14.2" cy="11" r="1.1"/><path d="M11 17.5v-1.6M13 17.5v-1.6"/>')],
    tcg: [svgm('<path d="M4 9.5l4-5h8l4 5-8 11z"/><path d="M4 9.5h16M12 20.5l-4-11M12 20.5l4-11"/>'),
      svgm('<path d="M12 2.5l8.2 4.75v9.5L12 21.5l-8.2-4.75v-9.5z"/><path d="M12 7l5 8.5H7z"/><path d="M12 2.5V7M3.8 7.25L7 15.5M20.2 7.25L17 15.5M12 21.5L7 15.5M12 21.5l5-6"/>'),
      svgm('<path d="M12 3l2 7 7 2-7 2-2 7-2-7-7-2 7-2z"/>')],
    all: [svgm('<rect x="6.5" y="3.5" width="11" height="17" rx="2" transform="rotate(-8 12 12)"/><path d="M12 9.2l.9 1.9 2 .3-1.5 1.4.4 2-1.8-1-1.8 1 .4-2-1.5-1.4 2-.3z"/>'),
      svgm('<path d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.8-5.2-2.8-5.2 2.8 1-5.8-4.3-4.1 5.9-.8z"/>'),
      svgm('<path d="M12 4l1.6 5.4L19 11l-5.4 1.6L12 18l-1.6-5.4L5 11l5.4-1.6z"/>')]
  };
  function fxWill(S, on) {
    var v = on ? 'transform, opacity' : '';
    var w = qs('.rli-wave', S.el); if (w) w.style.willChange = v;
    qsa('.rli-mot', S.el).forEach(function (m) { m.style.willChange = v; });
  }
  function fxStop(S) {
    var F = S.fx; if (!F) return;
    clearTimeout(F.t1); clearTimeout(F.t2); clearTimeout(F.t3);
    F.anims.forEach(function (an) { try { an.cancel(); } catch (e) { /* negeren */ } });
    F.anims = [];
    F.apply = null;
    S.fxHold = false;
    fxWill(S, false);
  }
  /* een lopende overgang meteen afronden (bv. Alles in mijn mandje tijdens de golf): eerst de nieuwe franchise samenstellen */
  function fxFlush(S) {
    var F = S.fx; if (!F || !F.apply) return;
    var ap = F.apply; F.apply = null; clearTimeout(F.t2);
    if (S.fxHold) { S.fxHold = false; paintFr(S, true); }
    ap();
  }
  function worldFx(S, tab, k, apply) {
    S.fx = S.fx || { anims: [], n: 0 };
    fxStop(S);
    var wave = qs('.rli-wave', S.el), content = qs('.rli-content', S.el), W = WORLD[k] || WORLD.all;
    if (S.RM || !tab || !wave || !content || !wave.animate || !tab.offsetWidth) { paintFr(S); if (apply) apply(); return; }
    var F = S.fx, E = 'cubic-bezier(.22,1,.36,1)';
    F.n++;
    S.fxHold = true;
    /* loopt het aanhaken van een vorige overgang nog: pauzeren tot deze overgang voorbij is */
    if (S.attQ && S.attQ.length) { clearTimeout(S.attT); S.attT = setTimeout(function () { attPump(S); }, FX_END + 80); }
    F.apply = apply || null;
    fxWill(S, true);
    var cr = content.getBoundingClientRect(), tr = tab.getBoundingClientRect(), vr = S.sc.getBoundingClientRect();
    var cx = tr.left + tr.width / 2 - cr.left, cy = tr.top + tr.height / 2 - cr.top;
    var x0 = vr.left - cr.left, y0 = vr.top - cr.top, x1 = x0 + vr.width, y1 = y0 + vr.height;
    var R = Math.ceil(Math.max(Math.hypot(cx - x0, cy - y0), Math.hypot(cx - x1, cy - y0), Math.hypot(cx - x0, cy - y1), Math.hypot(cx - x1, cy - y1)) + 12);
    wave.style.cssText = 'left:' + (cx - R) + 'px;top:' + (cy - R) + 'px;width:' + (2 * R) + 'px;height:' + (2 * R) + 'px;will-change:transform,opacity;background:radial-gradient(circle closest-side,' + W.in + ' 0%,' + W.out + ' 58%,' + W.out + ' 100%)';
    /* 1. golf: groeit in 700 ms (op FX_SWAP al ruim over het kader), vervaagt na de wissel */
    F.anims.push(wave.animate([{ transform: 'scale(.03)', opacity: 0 }, { transform: 'scale(.2)', opacity: 1, offset: .12 }, { transform: 'scale(1)', opacity: 1 }],
      { duration: 700, easing: E, fill: 'forwards' }));
    F.t1 = setTimeout(function () {
      if (!getState(S.el)) return;
      S.fxHold = false; paintFr(S, true);
      var a2 = wave.animate([{ transform: 'scale(1)', opacity: 1 }, { transform: 'scale(1)', opacity: 0 }], { duration: 660, delay: 0, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' });
      /* klaar: alle animaties van de golf weg, dan geldt weer de css (onzichtbaar); niets blijft hangen */
      a2.onfinish = function () { if (wave.getAnimations) wave.getAnimations().forEach(function (x) { x.cancel(); }); };
      F.anims.push(a2);
    }, FX_SWAP);
    /* 2. motieven: deterministisch per overgang (geen Math.random), verdeeld rondom de tegel, na de golf gestart */
    var rnd = mulberry32((F.n * 7919) >>> 0), set = MOTS[k] || MOTS.all, mots = qsa('.rli-mot', S.el);
    var N = Math.min(mots.length, S.mode === 'm' ? MOT_M : MOT_POOL), span = Math.max(vr.width, vr.height);
    for (var i = 0; i < N; i++) {
      var m = mots[i], key = k + (i % set.length);
      if (m._k !== key) { m._k = key; m.innerHTML = set[i % set.length]; }
      var dp = .35 + rnd() * .65, sz = Math.round(14 + 24 * dp), ang = (i / N) * Math.PI * 2 + (rnd() - .5) * .7;
      var dist = (90 + rnd() * span * .42) * (.55 + dp * .45);
      var ex = cx + Math.cos(ang) * dist, ey = cy + Math.sin(ang) * dist * .78, rot = (rnd() - .5) * 70;
      var bx = cx - sz / 2, by = cy - sz / 2, fx = ex - sz / 2, fy = ey - sz / 2;
      m.style.width = sz + 'px'; m.style.height = sz + 'px'; m.style.color = W.a;
      var peak = (.45 + .45 * dp).toFixed(2);
      F.anims.push(m.animate([
        { transform: 'translate(' + bx + 'px,' + by + 'px) scale(.3) rotate(0deg)', opacity: 0 },
        { transform: 'translate(' + (bx + (fx - bx) * .4) + 'px,' + (by + (fy - by) * .4) + 'px) scale(.8) rotate(' + (rot * .4) + 'deg)', opacity: peak, offset: .18 },
        { transform: 'translate(' + fx + 'px,' + fy + 'px) scale(1) rotate(' + rot + 'deg)', opacity: peak, offset: .55 },
        { transform: 'translate(' + fx + 'px,' + (fy + 14 + 26 * dp) + 'px) scale(.9) rotate(' + (rot * 1.15) + 'deg)', opacity: 0 }
      ], { duration: Math.round(700 + 120 * (1 - dp)), delay: 120 + i * 22, easing: E, fill: 'backwards' }));
    }
    /* zwaar werk na de piek: samenstellen en hertekenen */
    F.t2 = setTimeout(function () {
      if (!getState(S.el)) return;
      var ap = F.apply; F.apply = null;
      if (ap) ap();
    }, FX_APPLY);
    /* 3. landing: de linkerkolom zakt heel even in en veert terug, als laatste */
    var ctrl = qs(S.links === 'b' ? '.rli-intro' : '.rli-body', S.el);
    if (ctrl && ctrl.offsetWidth) F.anims.push(ctrl.animate([{ transform: 'none' }, { transform: 'translateY(5px) scale(.993)', offset: .4 }, { transform: 'none' }],
      { duration: 560, delay: 640, easing: E }));
    F.t3 = setTimeout(function () { if (getState(S.el)) fxWill(S, false); }, FX_END);
  }

  /* ---------------- stapel (desktop): een strook, elk product met zijn eigen balkje ---------------- */
  function deckItems(S) { return S.mode === 'd' ? S.lines.slice() : []; }
  function makeCard(S, l) {
    var c = document.createElement('div');
    c.className = 'rli-card'; c.setAttribute('data-h', l.handle); c.setAttribute('role', 'listitem');
    /* het beeld opent het product (klik, Enter of spatie); slepen op het model draait het (app.js) */
    c.innerHTML = '<div class="rli-cstage" tabindex="0" role="button"><div class="rli-glow"></div><div class="rli-drift"><div class="rli-cshadow"></div></div><span class="rli-qmark" hidden></span></div>' +
      '<div class="rli-cacts">' + actsHTML(S) + '</div><div class="rli-cbar"></div>';
    qs('.rli-drift', c).appendChild(makeVis(S, l.handle, true));
    var h = l.handle, im = qs('.rli-fb img', c);
    /* zonder vaste verhouding (ctx.ar) rekent cardFit met de foto: opnieuw passen zodra die er is */
    if (im) im.addEventListener('load', function () { if (S.deckEls.get(h) === c) cardFit(S, c); });
    qs('.rli-3d', c).addEventListener('cws-h3d', function (e) {
      if (e.detail && e.detail.on && S.deckEls.get(h) === c) aim3D(c);
    });
    c.addEventListener('pointerenter', function () { hot(S, h, true); });
    c.addEventListener('pointerleave', function () { hot(S, h, false); });
    return c;
  }
  function paintCard(S, c, l) {
    qs('.rli-cstage', c).setAttribute('aria-label', S.t.openAria(l.title));
    keepFocus(c, function () {
      /* naam tot 2 regels over de volle breedte, daaronder prijs en aantal; wisselen en verwijderen staan in de hoek van het vak */
      qs('.rli-cbar', c).innerHTML = nameBtn(S, l, 'rli-cname') + '<div class="rli-cctl"><span class="rli-cprice">' + eur(l.price * l.qty) + '</span>' + stepHTML(S, l) + '</div>';
    });
    var q = qs('.rli-qmark', c);
    if (l.qty > 1) { q.hidden = false; q.textContent = l.qty + 'x'; } else q.hidden = true;
  }
  /* een knop die focus had (- of + met het toetsenbord) houdt die na het hertekenen van zijn balkje */
  function keepFocus(node, fn) {
    var a = document.activeElement, act = a && node.contains(a) && a.getAttribute ? a.getAttribute('data-rli-act') : null;
    fn();
    if (!act) return;
    var b = qs('[data-rli-act="' + act + '"]', node);
    if (b && !b.disabled) { try { b.focus({ preventScroll: true }); } catch (e) { /* negeren */ } }
  }
  /* Raster (eigenaar 8 okt, na de strook: "hoe blijft alles een beetje even hoog zonder dat we te hard moeten swipen?"):
     tot 2 rijen van hoogstens 4 kaarten, elke kaart exact even groot (beeldvak plus naam, prijs en - aantal +), samen
     binnen het paneel dat even hoog is als de linkerkolom. Zo staan tot 8 producten zonder swipen in beeld. Meer dan er
     passen: per pagina, met pijlen opzij en stipjes eronder; kaarten van een andere pagina staan op display:none, zodat
     hun 3D-vak uit beeld is en de pool die plaatsen aan de zichtbare producten geeft (IntersectionObserver in app.js).
     Het beeldvak is hoogstens vierkant (geen hoge lege vakken meer) en het raster staat verticaal in het midden. Twee
     rijen enkel als het beeldvak dan nog minstens MIN_SH hoog is (op 1280x800 zou het 88 px worden: een pack van 70 px
     met de knoppen van 30 px erover); anders 1 rij per pagina. */
  /* Paginering: bij 2 rijen staan de pijlen opzij (kost breedte) en de stipjes eronder (DOTS_H); bij 1 rij staan pijlen
     en stipjes samen in een balk onder de rij (PG1_H), want daar is hoogte over en breedte schaars. */
  var MIN_CW = 150, MAX_COLS = 4, MAX_CW = 340, COL_GAP = 12, ROW_GAP = 10, MIN_SH = 110, PAGER_W = 40, DOTS_H = 16, PG1_H = 36;
  function deckGrid(W, H, n, bh) {
    var maxC = clamp(Math.floor((W + COL_GAP) / (MIN_CW + COL_GAP)), 1, MAX_COLS);
    function cand(r, c, w, h) {
      var cw = Math.min(MAX_CW, (w - COL_GAP * (c - 1)) / c), sh = Math.min((h - ROW_GAP * (r - 1)) / r - bh, cw);
      return { r: r, c: c, cw: cw, sh: sh, s: Math.min(sh * .74, cw * .88), paged: false };
    }
    if (n <= maxC) {
      var one = cand(1, Math.max(1, n), W, H), two = n > 1 ? cand(2, Math.ceil(n / 2), W, H) : null;
      return two && two.s > one.s ? two : one;
    }
    /* past alles in 2 rijen: geen paginering; meer dan 2 rijen vol: 2 rijen per pagina; is het beeldvak dan te laag:
       1 rij per pagina */
    var g = n <= 2 * maxC ? cand(2, Math.ceil(n / 2), W, H) : cand(2, maxC, W - 2 * PAGER_W, H - DOTS_H);
    if (g.sh < MIN_SH) { g = cand(1, maxC, W, H - PG1_H); g.pg1 = true; }
    g.paged = n > g.r * g.c;
    return g;
  }
  function layoutDeck(S) {
    var deck = qs('[data-rli-deck]', S.el), wrap = qs('.rli-deckwrap', S.el); if (!deck || !wrap || S.mode !== 'd') return;
    var W = wrap.clientWidth - 8, H = wrap.clientHeight, n = S.lines.length; if (!W || !H) return;
    /* meten op een zichtbare kaart: vanaf pagina 2 staat de eerste kaart op display:none (offsetHeight 0) */
    var bar = qs('.rli-card:not(.rli-off) .rli-cbar', deck), bh = bar && bar.offsetHeight ? bar.offsetHeight + 6 : (S.barH || 72);
    if (bar && bar.offsetHeight) S.barH = bh;
    var g = deckGrid(W, H, n, bh), first = (S.pg || 0) * (S.per || 8);
    /* andere kaarten per pagina (resize): op de pagina blijven met het eerste product dat in beeld was */
    S.grid = g; S.per = g.r * g.c; S.pg = Math.floor(first / S.per);
    var set = function (node, k, val) { if (node.style.getPropertyValue(k) !== val) node.style.setProperty(k, val); };
    set(deck, '--cw', Math.floor(g.cw) + 'px');
    set(deck, '--sh', Math.floor(Math.max(40, g.sh)) + 'px');
    set(deck, '--cols', String(g.c));
    wrap.classList.toggle('rli-paged', g.paged);
    wrap.classList.toggle('rli-pg1', !!(g.paged && g.pg1));
    paintPage(S, 0);
    S.deckEls.forEach(function (c) { cardFit(S, c); });
  }
  /* Optisch even groot (eigenaar 8 okt: "Mega Charizard vult de hele breedte, de Tin klein in het midden"): elk product
     krijgt dezelfde zichtbare oppervlakte als een vierkant product van FILL_H van het beeldvak hoog, op basis van zijn
     eigen verhouding (ctx.ar, de vaste cut-meta; anders de foto). Staande producten worden zo hoger (tot MAX_H van het
     vak), brede producten worden op hun breedte begrensd (MAX_W) en lager, zodat ze niet zwaarder ogen dan de rest.
     Tins, blisters en bundels (veel lucht rond het product in de foto) iets groter (BOOST). */
  var FILL_H = .7, MAX_H = .83, MAX_W = .88, BOOST = 1.1, BOOST_RE = /\bTin\b|Blister|Booster Bundle/i;
  function prodTarget(Ws, Hs, ar, kind) {
    var A = FILL_H * FILL_H * Hs * Hs * (BOOST_RE.test(kind || '') ? BOOST * BOOST : 1);
    var th = Math.sqrt(A / ar), tw = th * ar, k = Math.min(1, MAX_H * Hs / th, MAX_W * Ws / tw);
    return { w: tw * k, h: th * k };
  }
  /* mountHero3D (app.js) past het model zelf in zijn vak: hoogte min(sqrt(area*W*Hb/ar), 0.9*W/ar, 0.96*Hb), met
     Hb = vakhoogte - FIT_GAP, onderaan gecentreerd; fitImg doet hetzelfde met de foto. Het vak (.rli-vis) krijgt per
     product precies de maat waarbij die regel het doel geeft: Hb = th / 0.96 en een breedte waarbij de andere twee
     termen niet kleiner uitvallen. Zo staan foto en eerste 3D-beeld al op de juiste maat; daarna legt aim3D het model
     exact op het doel. Het vak mag opzij buiten het beeldvak lopen; .rli-cstage knipt het af (overflow hidden). */
  function cardFit(S, c) {
    var g = S.grid, v = qs('.rli-vis', c); if (!g || !v) return;
    var h = c.getAttribute('data-h'), p = S.byH[h] || {}, img = qs('.rli-fb img', v);
    var ar = (S.ctx.ar && +S.ctx.ar(h)) || (img && img.naturalWidth ? img.naturalWidth / img.naturalHeight : 0) || .75;
    var Ws = Math.floor(g.cw), Hs = Math.floor(Math.max(40, g.sh)), t = prodTarget(Ws, Hs, ar, p.kind), area = fitArea(p);
    var Hb = t.h / .96, Wv = Math.max(t.w / .9, .96 * t.w / area) * 1.004, bot = Math.max(7, Math.round(Hs * .055));
    var key = [Ws, Hs, ar].join('|');
    if (v._fitKey === key) return;
    v._fitKey = key;
    v._f = { ws: Ws, hs: Hs, bot: bot, l: (Ws - Wv) / 2, t: Hs - bot - Hb, tw: t.w, th: t.h };
    v.style.left = v._f.l.toFixed(1) + 'px'; v.style.top = v._f.t.toFixed(1) + 'px';
    v.style.width = Wv.toFixed(1) + 'px'; v.style.height = (Hb + FIT_GAP).toFixed(1) + 'px';
    v.setAttribute('data-tw', Math.round(t.w)); v.setAttribute('data-th', Math.round(t.h));
    var sh = qs('.rli-cshadow', c);
    if (sh) { sh.style.left = ((Ws - t.w * .7) / 2).toFixed(1) + 'px'; sh.style.width = (t.w * .7).toFixed(1) + 'px'; sh.style.bottom = (bot - 4) + 'px'; }
    if (img) fitImg(img);
    if (v.classList.contains('rli-3don')) aim3D(c);
  }
  /* Het 3D-model toont aan de heldpose ook een zijkant, dus zijn silhouet heeft een andere verhouding dan de foto (een
     doos tot 10% groter, een collectie soms kleiner). Zodra het model er staat (cws-h3d) en na elke maatwijziging van het
     vak: zijn echte projectie lezen (debugFrame van de motor) en het met retarget (Stage3D, zonder de scene opnieuw op te
     bouwen) op een rechthoek met dezelfde oppervlakte als het doel leggen, met de verhouding van dat silhouet, onderaan
     in het beeldvak. Zonder die functies (oudere motor) blijft de maat van mountHero3D staan. */
  function aim3D(c) {
    var v = qs('.rli-vis', c), d = qs('.rli-3d', c), inst = d && d._h3d, f = v && v._f, fr = null;
    if (!f || !inst || !inst.owns || !inst.owns(d) || !inst.debugFrame || !inst.retarget) return;
    try { fr = inst.debugFrame(); } catch (e) { fr = null; }
    var pw = fr && fr.proj && fr.proj.w, ph = fr && fr.proj && fr.proj.h;
    if (!(pw > 4) || !(ph > 4)) return;
    var rho = pw / ph, h = Math.sqrt(f.tw * f.th / rho), w = h * rho, k = Math.min(1, MAX_W * f.ws / w, .88 * f.hs / h);
    w *= k; h *= k;
    try { inst.retarget({ x: (f.ws - w) / 2 - f.l, y: f.hs - f.bot - h - f.t, w: w, h: h }, d); } catch (e) { /* negeren */ }
  }
  function pages(S) { return Math.max(1, Math.ceil(S.lines.length / Math.max(1, S.per || 8))); }
  /* pagina tonen: enkel de kaarten van die pagina zichtbaar; dir (-1 of 1) schuift de nieuwe kaarten zacht in */
  function paintPage(S, dir) {
    var deck = qs('[data-rli-deck]', S.el); if (!deck) return;
    var np = pages(S), per = Math.max(1, S.per || 8);
    S.pg = clamp(S.pg || 0, 0, np - 1);
    var lo = S.pg * per, hi = lo + per, shown = [];
    S.lines.forEach(function (l, i) {
      var c = S.deckEls.get(l.handle); if (!c) return;
      var on = i >= lo && i < hi;
      if (c.classList.contains('rli-off') !== on) return;
      c.classList.toggle('rli-off', !on);
      /* een kaart van een andere pagina geeft zijn 3D-plaats meteen vrij; terug in beeld haakt hij opnieuw aan */
      if (on) shown.push(c); else killVis(qs('.rli-vis', c));
    });
    if (dir && !S.RM) shown.forEach(function (c, k) {
      if (c.animate) c.animate([{ opacity: 0, transform: 'translateX(' + (dir * 28) + 'px)' }, { opacity: 1, transform: 'none' }], { duration: 340, delay: k * 28, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
    });
    shown.forEach(function (c) { cardFit(S, c); var v = qs('.rli-vis', c), im = qs('.rli-fb img', c); if (im) fitImg(im); if (v && !v._ctl && v.isConnected) attachSoon(S, v, c.getAttribute('data-h'), 0); });
    paintPager(S);
    if (dir) measureSoon(S);
  }
  function paintPager(S) {
    var p = qs('[data-rli-sprev]', S.el), x = qs('[data-rli-snext]', S.el), dots = qs('[data-rli-pdots]', S.el), bar = qs('[data-rli-pager]', S.el);
    if (!p || !x || !dots || !bar) return;
    var np = pages(S), on = S.mode === 'd' && np > 1;
    bar.hidden = !on;
    if (!on) { if (dots.innerHTML) dots.innerHTML = ''; return; }
    /* focus op een pijl die uitgaat (eerste of laatste pagina): naar de andere pijl, niet terug naar body */
    var fp = document.activeElement === p && S.pg <= 0, fx = document.activeElement === x && S.pg >= np - 1;
    p.disabled = S.pg <= 0; x.disabled = S.pg >= np - 1;
    if (fp) x.focus({ preventScroll: true }); else if (fx) p.focus({ preventScroll: true });
    if (dots.children.length !== np) {
      var o = '';
      for (var d = 0; d < np; d++) o += '<button type="button" class="rli-pdot" data-rli-page="' + d + '" aria-label="' + esc(S.t.pageAria(d + 1, np)) + '" title="' + esc(S.t.pageAria(d + 1, np)) + '"><i></i></button>';
      dots.innerHTML = o;
    }
    qsa('.rli-pdot', dots).forEach(function (b, i) { b.setAttribute('aria-current', String(i === S.pg)); });
    var live = qs('[data-rli-plive]', S.el), msg = S.t.pageAria(S.pg + 1, np);
    if (live && live.textContent !== msg) live.textContent = msg;
  }
  function setPage(S, pg) {
    var to = clamp(pg, 0, pages(S) - 1), dir = to > (S.pg || 0) ? 1 : to < (S.pg || 0) ? -1 : 0;
    if (!dir) return;
    S.pg = to; paintPage(S, dir);
  }
  function wirePager(S) {
    S.on(qs('[data-rli-sprev]', S.el), 'click', function () { setPage(S, (S.pg || 0) - 1); });
    S.on(qs('[data-rli-snext]', S.el), 'click', function () { setPage(S, (S.pg || 0) + 1); });
    S.on(qs('[data-rli-pdots]', S.el), 'click', function (e) { var b = e.target.closest('[data-rli-page]'); if (b) setPage(S, +b.getAttribute('data-rli-page')); });
  }
  function renderDeck(S, animate) {
    var deck = qs('[data-rli-deck]', S.el);
    var fresh = reconcile(S, S.deckEls, deck, function (l) { return makeCard(S, l); }, function (c, l) { paintCard(S, c, l); }, animate, function (n, k) {
      if (S.soft) n.animate([{ opacity: 0, transform: 'translateY(26px) scale(.97)' }, { opacity: 1, transform: 'none' }], { duration: 520, delay: 40 + Math.min(k, 6) * 45, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
      else n.animate([{ opacity: 0, transform: 'translateY(48px) scale(.94)' }, { opacity: 1, transform: 'none' }], { duration: 680, delay: 60 + Math.min(k, 6) * 70, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
    });
    layoutDeck(S);
    fresh.forEach(function (c) { attachSoon(S, qs('.rli-vis', c), c.getAttribute('data-h'), 0); });
  }
  function hot(S, h, onn) {
    S.hot = onn ? h : (S.hot === h ? null : S.hot);
    [S.deckEls, S.fullEls].forEach(function (m) { var n = m.get(h); if (n) n.classList.toggle('rli-hot', onn); });
  }
  function paintSel(S) {
    if (S.sel && idxOf(S, S.sel) < 0) S.sel = null;
    [S.deckEls, S.fullEls].forEach(function (m) { m.forEach(function (n, h) { n.classList.toggle('rli-sel', h === S.sel); }); });
  }
  function select(S, h) {
    S.sel = S.sel === h ? null : h;
    paintSel(S);
    if (!S.sel) return;
    if (S.mode === 'm') { var i = idxOf(S, h); if (i >= 0) goTo(S, i, true); return; }
    revealCard(S, h);
  }
  /* het product in het raster tonen: naar zijn pagina (de pagina zelf scrolt niet mee) */
  function revealCard(S, h) {
    var c = S.deckEls.get(h), i = idxOf(S, h); if (!c || i < 0) return;
    setPage(S, Math.floor(i / Math.max(1, S.per || 8)));
    flash(S, c);
  }
  function flash(S, n) { if (!n || S.RM) return; n.classList.remove('rli-flash'); void n.offsetWidth; n.classList.add('rli-flash'); }

  /* ---------------- 3D: rustig wiegen als niemand het aanraakt (zoals riplab-skills/cw3d-frame.html) ----------------
     Eén gedeelde requestAnimationFrame-lus voor alle modellen van deze component. Per model (het 3D-vak .rli-3d, met de
     instantie die app.js daar als el._h3d zet zodra het een plek uit de pool krijgt): na 1,4 s zonder muis of sleep
     zachtjes wiegen met pointer(sin(t/1400)*0.38, cos(t/1900)*0.1), elk model met een eigen faseverschuiving. Hover
     (cursor volgen) en slepen (met naloop) doet app.js zelf; dan wiegt het niet. Geen wiegen voor een model zonder
     instantie of buiten beeld (_h3dM.vis, dezelfde IntersectionObserver als de pool); de lus stopt zolang de tab
     verborgen is of de component niet in beeld staat, en start weer via swayStart (interval en visibilitychange).
     Reduced motion: geen wiegen. */
  /* Pauzeren: app.js pauzeert een pool-instantie bij het toewijzen zolang de actieve scene van de feed niet het
     startscherm is; in de Clean-laag (Rip Lab) bleef het model daardoor stilstaan (geen zweven, geen kanteling, geen
     naloop na slepen). Deze lus zet daarom de instanties die bij een vak van DEZE component horen zelf aan zolang dat
     vak in beeld is, en weer op pauze als het uit beeld gaat of de lus stopt. pause(false) zet de klok van de motor
     terug, dus enkel bij een wissel (en hoogstens 1x per seconde ter bevestiging), nooit elk frame. */
  var SWAY_IDLE = 1400;
  function swayStart(S) {
    if (S.swayRaf || !getState(S.el) || document.hidden) return;
    var f = function (t) {
      S.swayRaf = 0;
      if (!getState(S.el)) return;
      if (document.hidden || !isShown(S)) { swayPauseAll(S); return; }
      swayTick(S, t);
      S.swayRaf = requestAnimationFrame(f);
    };
    S.swayRaf = requestAnimationFrame(f);
  }
  function swayEach(S, fn) {
    var k = 0;
    [S.deckEls, S.slideEls, S.fullEls].forEach(function (map) {
      map.forEach(function (n) {
        k++;
        var d = n._d3 || (n._d3 = qs('.rli-3d', n)); if (!d) return;
        var inst = d._h3d;
        if (!inst || !inst.pointer || !inst.owns || !inst.owns(d)) return;
        fn(d, inst, k);
      });
    });
  }
  function swayRun(d, inst, want, t) {
    if (d._rliInst !== inst || d._rliRun !== want || (want && t - (d._rliRunT || 0) > 1000)) {
      d._rliInst = inst; d._rliRun = want; d._rliRunT = t;
      try { inst.pause(!want); } catch (e) { /* negeren */ }
    }
  }
  function swayPauseAll(S) { var t = performance.now(); swayEach(S, function (d, inst) { swayRun(d, inst, false, t); }); }
  function swayTick(S, t) {
    swayEach(S, function (d, inst, k) {
      var vis = !(d._h3dM && !d._h3dM.vis);
      swayRun(d, inst, vis, t);
      if (!vis || S.RM) return;
      if (S.swayDown === d || d.classList.contains('cws-h3d-hov') || t - (d._rliLast || 0) < SWAY_IDLE) return;
      if (d._rliPh == null) d._rliPh = (k * 1931) % 7000;
      inst.pointer(Math.sin((t + d._rliPh) / 1400) * .38, Math.cos((t + d._rliPh) / 1900) * .1);
    });
  }
  function wireSway(S) {
    var mark = function (e) { var d = e.target && e.target.closest && e.target.closest('.rli-3d'); if (d) d._rliLast = performance.now(); return d; };
    S.on(S.el, 'pointermove', mark, { passive: true });
    S.on(S.el, 'pointerdown', function (e) { S.swayDown = mark(e); }, { passive: true });
    var up = function () { if (S.swayDown) { S.swayDown._rliLast = performance.now(); S.swayDown = null; } };
    S.on(window, 'pointerup', up); S.on(window, 'pointercancel', up);
    S.on(document, 'visibilitychange', function () { if (!document.hidden) swayStart(S); });
    swayStart(S);
  }

  /* ---------------- regels, kaarten en slides (per handle hergebruikt) ---------------- */
  function stepHTML(S, l) {
    return '<div class="rli-step"><button type="button" class="rli-ib" data-rli-act="minus" aria-label="' + esc(S.t.minus) + '" title="' + esc(S.t.minus) + '">' + ICON.minus + '</button>' +
      '<span class="rli-qty" aria-live="polite">' + l.qty + '</span>' +
      '<button type="button" class="rli-ib" data-rli-act="plus" aria-label="' + esc(S.t.plus) + '" title="' + esc(S.t.plus) + '"' + (canPlus(S, l) ? '' : ' disabled') + '>' + ICON.plus + '</button></div>';
  }
  function actsHTML(S) {
    return '<button type="button" class="rli-ib rli-ibswap" data-rli-act="swap" aria-label="' + esc(S.t.swap) + '" title="' + esc(S.t.swapTitle) + '">' + ICON.swap + '</button>' +
      '<button type="button" class="rli-ib rli-ibx" data-rli-act="remove" aria-label="' + esc(S.t.remove) + '" title="' + esc(S.t.remove) + '">' + ICON.x + '</button>';
  }
  /* het aantal staat al bij - aantal +, dus hier enkel de soort en bij meer dan 1 de stukprijs (past op 1 regel) */
  function subText(S, l) { var k = kindOf(S, l.handle); return k + (l.qty > 1 ? (k ? ', ' : '') + S.t.each(eur(l.price)) : ''); }
  function nameBtn(S, l, cls) {
    return '<button type="button" class="' + cls + '" data-rli-act="open" title="' + esc(l.title) + '" aria-label="' + esc(S.t.openAria(l.title)) + '"><span class="rli-ntxt">' + esc(l.title) + '</span></button>';
  }
  /* gedeelde verzoening: verwijderen wat weg is, nieuwe maken, alles in de juiste volgorde zetten */
  function reconcile(S, map, list, build, update, animate, onNew) {
    var keep = {}; S.lines.forEach(function (l) { keep[l.handle] = 1; });
    /* na een wereldovergang (S.stagger) de 3D van wat weg is pas later vrijgeven (attPump): anders pakken de producten die
       blijven meteen de vrijgekomen instanties en laadt de pool hun modellen midden in de overgang (lang frame) */
    map.forEach(function (n, h) { if (!keep[h]) { if (S.stagger) qsa('.rli-vis', n).forEach(function (v) { if (v._ctl) attQueue(S, { k: v, p: -1 }); }); else killIn(n); n.remove(); map.delete(h); } });
    var ref = list.firstElementChild, fresh = [], k = 0;
    S.lines.forEach(function (l, i) {
      var n = map.get(l.handle), isNew = !n;
      if (isNew) { n = build(l, i); map.set(l.handle, n); }
      n.style.pointerEvents = ''; n.style.opacity = '';
      update(n, l, i);
      if (n === ref) ref = ref.nextElementSibling; else list.insertBefore(n, ref);
      if (isNew) fresh.push(n);
      if (isNew && animate && !S.RM && n.animate && onNew) onNew(n, k++, i);
    });
    return fresh;
  }
  function renderFull(S, animate) {
    var list = qs('[data-rli-frows]', S.el);
    var fresh = reconcile(S, S.fullEls, list, function (l) {
      var li = document.createElement('li');
      li.className = 'rli-fcard'; li.setAttribute('data-h', l.handle);
      li.innerHTML = '<div class="rli-frame"><div class="rli-move"></div><span class="rli-qmark" hidden></span></div><div class="rli-fbody"></div>';
      qs('.rli-move', li).appendChild(makeVis(S, l.handle, false));
      var h = l.handle;
      li.addEventListener('pointerenter', function () { hot(S, h, true); });
      li.addEventListener('pointerleave', function () { hot(S, h, false); });
      return li;
    }, function (li, l) {
      keepFocus(li, function () { qs('.rli-fbody', li).innerHTML = '<div class="rli-fmeta">' + nameBtn(S, l, 'rli-fname') + '<span class="rli-fcat">' + esc(subText(S, l)) + '</span></div>' +
        '<div class="rli-fprice">' + eur(l.price * l.qty) + '</div>' + stepHTML(S, l) + '<div class="rli-facts">' + actsHTML(S) + '</div>'; });
      var q = qs('.rli-qmark', li);
      if (l.qty > 1) { q.hidden = false; q.textContent = l.qty + 'x'; } else q.hidden = true;
    }, animate, function (n, k) {
      n.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 420, delay: k * 50, easing: 'ease-out', fill: 'backwards' });
    });
    fresh.forEach(function (li) { attachSoon(S, qs('.rli-vis', li), li.getAttribute('data-h'), 1); });
    qs('[data-rli-fempty]', S.el).classList.toggle('rli-show', !S.lines.length);
  }
  function renderSlides(S, animate) {
    var track = qs('[data-rli-track]', S.el), n = S.lines.length;
    if (S.mode === 'm') {
      var fresh = reconcile(S, S.slideEls, track, function (l) {
        var s = document.createElement('div');
        s.className = 'rli-slide'; s.setAttribute('data-h', l.handle);
        s.setAttribute('role', 'group'); s.setAttribute('aria-roledescription', 'product');
        s.innerHTML = '<div class="rli-sstage"><span class="rli-qmark" hidden></span></div><div class="rli-sinfo"></div>';
        qs('.rli-sstage', s).insertBefore(makeVis(S, l.handle, true), qs('.rli-qmark', s));
        return s;
      }, function (s, l, i) {
        s.setAttribute('aria-label', S.t.slideOf(i + 1, n, l.title));
        keepFocus(s, function () { qs('.rli-sinfo', s).innerHTML = nameBtn(S, l, 'rli-sname') + '<div class="rli-srow"><span class="rli-sprice">' + eur(l.price * l.qty) + '</span>' + stepHTML(S, l) + actsHTML(S) + '</div>'; });
        var q = qs('.rli-qmark', s);
        if (l.qty > 1) { q.hidden = false; q.textContent = l.qty + 'x'; } else q.hidden = true;
      }, animate, function (node, k, i) {
        if (i === S.car) qs('.rli-sstage', node).animate([{ opacity: 0, transform: 'translateY(30px)' }, { opacity: 1, transform: 'none' }], { duration: 560, easing: 'cubic-bezier(.22,1,.36,1)' });
      });
      fresh.forEach(function (s) { attachSoon(S, qs('.rli-vis', s), s.getAttribute('data-h'), 0); });
    }
    var dots = '';
    for (var d = 0; d < n; d++) dots += '<button type="button" class="rli-dot" data-i="' + d + '" aria-label="' + esc(S.t.dotAria(d + 1, n)) + '"></button>';
    qs('[data-rli-dots]', S.el).innerHTML = dots;
    S.car = clamp(S.car, 0, Math.max(0, n - 1));
    qsa('[data-rli-prev],[data-rli-next]', S.el).forEach(function (b) { b.hidden = !n; });
    paintCar(S);
  }
  function paintCar(S) {
    var n = S.lines.length;
    qsa('.rli-dot', S.el).forEach(function (d, i) { d.setAttribute('aria-current', String(i === S.car)); });
    var p = qs('[data-rli-prev]', S.el), x = qs('[data-rli-next]', S.el);
    if (p) p.disabled = S.car <= 0;
    if (x) x.disabled = S.car >= n - 1;
  }
  function goTo(S, i, smooth) {
    var n = S.lines.length, track = qs('[data-rli-track]', S.el); if (!n || S.mode !== 'm') return;
    S.car = clamp(i, 0, n - 1);
    var w = track.clientWidth;
    if (w) track.scrollTo({ left: S.car * w, behavior: smooth && !S.RM ? 'smooth' : 'auto' });
    paintCar(S);
  }
  function wireCarousel(S) {
    var track = qs('[data-rli-track]', S.el), raf = 0;
    S.on(track, 'scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0; var w = track.clientWidth; if (!w) return;
        var i = Math.round(track.scrollLeft / w);
        if (i !== S.car) { S.car = clamp(i, 0, Math.max(0, S.lines.length - 1)); paintCar(S); }
      });
    }, { passive: true });
    S.on(qs('[data-rli-prev]', S.el), 'click', function () { goTo(S, S.car - 1, true); });
    S.on(qs('[data-rli-next]', S.el), 'click', function () { goTo(S, S.car + 1, true); });
    S.on(qs('[data-rli-dots]', S.el), 'click', function (e) { var d = e.target.closest('.rli-dot'); if (d) goTo(S, +d.getAttribute('data-i'), true); });
  }

  /* ---------------- lege stand ---------------- */
  function renderEmpty(S) {
    var none = !S.lines.length, t = S.t, box = qs('[data-rli-empty]', S.el), car = qs('[data-rli-carempty]', S.el), miss = S.typeMiss;
    var min = none ? (miss ? miss.min : cheapestInFranchise(S.ctx.products, S.franchise)) : null;
    var h = none ? '<p>' + esc(miss ? t.emptyType : t.empty) + '</p><div class="rli-eacts">' +
      (min && min > S.budget ? '<button type="button" class="rli-btn rli-btn-pri rli-btn-sm" data-rli-setmin="' + min + '">' + esc(t.setMin(min)) + '</button>' : '') +
      (miss ? '<button type="button" class="rli-btn rli-btn-sec rli-btn-sm" data-rli-alltypes>' + esc(t.allTypes) + '</button>' :
        S.franchise !== 'mix' ? '<button type="button" class="rli-btn rli-btn-sec rli-btn-sm" data-rli-showall>' + esc(t.showAll) + '</button>' : '') + '</div>' : '';
    [box, car].forEach(function (b) { if (b) { b.innerHTML = h; b.classList.toggle('rli-show', none); } });
  }

  /* ---------------- acties per regel (lijst, kaarten, carrousel) ---------------- */
  function wireLines(S) {
    /* klik of sleep: een klik op een model opent het product, slepen (6 px of meer) draait het enkel */
    var down = null;
    S.on(S.el, 'pointerdown', function (e) { down = { x: e.clientX, y: e.clientY, vis: !!(e.target.closest && e.target.closest('.rli-vis')) }; }, true);
    function dragged(e) { return !!down && Math.hypot(e.clientX - down.x, e.clientY - down.y) >= 6; }
    function openProduct(h, node) { if (S.ctx.on && S.ctx.on.product) S.ctx.on.product(h, qs('.rli-vis img, .rli-thumb img', node)); }
    S.on(S.el, 'click', function (e) {
      var tg = e.target, b;
      /* enkel een echte pointerklik (detail > 0, dus geen Enter of spatie met clientX/Y 0) die in het beeld begon telt als
         slepen (ook als je naast het beeld loslaat); een tap met wat beweging op een knop blijft een klik */
      if (e.detail > 0 && dragged(e) && down.vis) { down = null; return; }
      if ((b = tg.closest('[data-franchise3]'))) { var tb = qs('.rli-tab[data-f="' + b.getAttribute('data-franchise3') + '"]', S.el); if (tb) tb.click(); return; }
      if ((b = tg.closest('[data-rli-setmin]'))) { setBudget(S, +b.getAttribute('data-rli-setmin'), 'chip'); return; }
      if ((b = tg.closest('[data-rli-showall]'))) { var a = qs('.rli-tab[data-f="mix"]', S.el); if (a) a.click(); return; }
      /* strook: het beeld opent het product; het balkje eronder heeft zijn eigen knoppen */
      if (tg.closest('.rli-cstage')) { var cd = tg.closest('.rli-card'); if (cd) openProduct(cd.getAttribute('data-h'), cd); return; }
      var node = tg.closest('.rli-card,.rli-fcard,.rli-slide'); if (!node) return;
      var h = node.getAttribute('data-h'), i = idxOf(S, h); if (i < 0) return;
      var l = S.lines[i], btn = tg.closest('[data-rli-act]'), act = btn ? btn.getAttribute('data-rli-act') : '';
      if (act === 'open') { if (S.ctx.on && S.ctx.on.product) S.ctx.on.product(h, qs('.rli-vis img, .rli-thumb img', node)); return; }
      /* enkel het beeld (kader onderaan, podium van de slide, het 3D-model) opent het product; elders in een rij of kaart
         selecteren (de slide heeft niets te selecteren) */
      if (!act || act === 'pick') {
        if (!act && tg.closest('.rli-frame,.rli-sstage,.rli-vis')) { openProduct(h, node); return; }
        if (node.classList.contains('rli-fcard')) select(S, h);
        return;
      }
      if (act === 'plus') { if (canPlus(S, l)) { l.qty++; edited(S); } }
      else if (act === 'minus') { if (l.qty > 1) { l.qty--; edited(S); } else removeLine(S, node, h); }
      else if (act === 'remove') removeLine(S, node, h);
      else if (act === 'swap') swapLine(S, l, btn);
    });
    /* strook met het toetsenbord: Enter of spatie op het beeld opent het product */
    S.on(qs('[data-rli-deck]', S.el), 'keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var st = e.target.closest('.rli-cstage'); if (!st || st !== e.target) return;
      var c = st.closest('.rli-card');
      e.preventDefault(); openProduct(c.getAttribute('data-h'), c);
    });
  }
  function edited(S) { S.isManual = true; S.noOther = false; changed(S); render(S, 'edit'); }
  function removeLine(S, node, h) {
    var gen = S.gen;
    var done = function () { if (getState(S.el) !== S || gen !== S.gen) return; S.lines = S.lines.filter(function (l) { return l.handle !== h; }); edited(S); };
    if (S.RM || !node.animate) return done();
    node.style.pointerEvents = 'none';
    var a = node.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: node.classList.contains('rli-slide') ? 'translateY(24px)' : 'translateX(30px)' }], { duration: 240, easing: 'ease-in', fill: 'forwards' });
    a.onfinish = done;
  }
  /* wisselen: zelfde regel als replaceInManual in start-scene.js (dichtstbijzijnde prijs, zelfde soort en franchise,
     past in het budget, elke volgende klik op dezelfde plek een ander alternatief) */
  function swapLine(S, l, btn) {
    var idx = S.lines.indexOf(l), oldP = findProduct(S.ctx, l.handle), cat = oldP ? classifyProduct(oldP) : null;
    var used = {}; S.lines.forEach(function (x) { if (x !== l) used[x.handle] = 1; });
    var room = round2(S.budget - round2(total(S) - l.price * l.qty));
    var unitLimit = Math.max(l.price, room / Math.max(1, l.qty));
    var slot = l._slotKey || l.handle, seen = S.replaceSeen[slot] || [l.handle];
    function pool(sameCat) {
      return (S.ctx.products || []).filter(function (p) {
        return p && p.av !== false && p.type !== 'acc' && !used[p.handle] && p.handle !== l.handle && seen.indexOf(p.handle) === -1 &&
          productMatchesFranchise(p, S.franchise) && (!sameCat || classifyProduct(p) === cat) && p.price <= unitLimit + 1e-9;
      }).sort(function (a, b) { return Math.abs(a.price - l.price) - Math.abs(b.price - l.price); });
    }
    var c = cat ? pool(true) : [];
    if (!c.length && seen.length > 1) { seen = [l.handle]; c = cat ? pool(true) : []; }
    if (!c.length) c = pool(false);
    if (!c.length && seen.length > 1) { seen = [l.handle]; c = pool(false); }
    if (!c.length || idx < 0) {
      if (!S.RM && btn) { btn.classList.remove('rli-shake'); void btn.offsetWidth; btn.classList.add('rli-shake'); }
      toast(S, S.t.noAlt);
      return;
    }
    var pick = c[0], wasSel = S.sel === l.handle;
    seen.push(pick.handle); S.replaceSeen[slot] = seen;
    S.lines[idx] = { handle: pick.handle, title: pick.title, price: pick.price, type: pick.type, qty: l.qty, _slotKey: slot };
    if (wasSel) S.sel = pick.handle;
    edited(S);
    flash(S, S.deckEls.get(pick.handle)); flash(S, S.fullEls.get(pick.handle));
  }

  /* ---------------- totalen ---------------- */
  function paintTotals(S) {
    var t = S.t, tot = total(S), b = S.budget, ratio = b ? clamp(tot / b, 0, 1) : 0, rest = Math.max(0, round2(b - tot)), u = units(S), n = S.lines.length;
    var from = S.shown, id = S.totId = (S.totId || 0) + 1, t0 = performance.now(), ofs = qsa('[data-rli-of]', S.el);
    (function frame(now) {
      if (id !== S.totId || !getState(S.el)) return;
      var k = S.RM ? 1 : clamp((now - t0) / 420, 0, 1), v = from + (tot - from) * (1 - Math.pow(1 - k, 3));
      S.shown = v;
      ofs.forEach(function (o) { o.textContent = t.of(v, b); });
      if (k < 1) requestAnimationFrame(frame);
    })(t0);
    qsa('[data-rli-over]', S.el).forEach(function (o) { o.textContent = n ? t.over(rest) : ''; });
    qsa('[data-rli-bar]', S.el).forEach(function (o) { o.style.transform = 'scaleX(' + ratio + ')'; });
    qsa('[data-rli-count]', S.el).forEach(function (o) { o.textContent = n; });
    qs('[data-rli-fsub]', S.el).textContent = n ? t.fSub(u, tot) : t.fSubEmpty;
    qs('[data-rli-psub]', S.el).textContent = n ? t.pSub(u) : '';
    /* eerlijk: blijft een voorstel van CARDIX ver onder het budget (minder dan 90% en meer dan 20 euro over), dan is er
       binnen de keuzes niet meer; dat zeggen we kort, in plaats van te zwijgen. Niet na eigen aanpassingen. */
    paintNote(S, n > 0 && !S.isManual && tot < b * 0.9 && rest >= 20);
    /* thermometer: vulling van onder naar boven, het restbedrag schuift mee met het peil */
    qs('[data-rli-tube]', S.el).style.transform = 'scaleY(' + ratio + ')';
    var mk = qs('[data-rli-mark]', S.el), tube = qs('.rli-tube', S.el), th = tube.clientHeight;
    mk.textContent = n ? t.over(rest) : t.budgetMark(b);
    if (th) mk.style.transform = 'translateY(' + clamp(4 + (th - 8) * (1 - ratio) - 10, 0, th - 20) + 'px)';
  }
  /* De melding onder de balk. Beperkt een eigen keuze (soort of samenstelling) het resultaat, dan zegt ze precies welke
     keuze en hoeveel er binnen past, met een knop die de keuze in een klik opheft. Zonder keuze: de korte, eerlijke
     melding dat er binnen het budget niet meer is. */
  function filterInfo(S) {
    var v = prefView(S), t = S.t;
    if (!v.types.length && v.style === 'mixed') return null;
    var lbl = v.types.map(function (id) { return t.types[id] || id; });
    if (v.style !== 'mixed') lbl.push(t.style[v.style]);
    var n = 0;
    (S.ctx.products || []).forEach(function (p) {
      if (p && p.av !== false && p.type !== 'acc' && p.price <= S.budget + 1e-9 && productMatchesFranchise(p, S.franchise) && v.types.indexOf(classifyProduct(p)) !== -1) n++;
    });
    var fr = S.franchise === 'mix' ? t.inMix : S.franchise ? t.fr[S.franchise] : t.frOther.join('');
    return t.fNote(lbl.join(', '), fr, n, v.types.length ? 'types' : v.style);
  }
  function paintNote(S, under) {
    if (under == null) under = S.under; S.under = under;
    var fl = (under || S.noOther) && S.lines.length ? filterInfo(S) : null, t = S.t;
    var capped = under && S.lines.some(function (l) { return l.qty >= QTY_CAP; });
    var h = fl ? esc(fl) + ' <button type="button" class="rli-link" data-rli-clearf>' + esc(t.clearF) + '</button>' : capped ? esc(t.capNote(QTY_CAP)) : under ? esc(t.under) : '';
    qsa('[data-rli-note]', S.el).forEach(function (o) { o.hidden = !h; if (o.getAttribute('data-h') !== h) { o.setAttribute('data-h', h); o.innerHTML = h; } });
  }
  function paintConfirm(S) {
    var c = S.confirmed, t = S.t;
    qsa('[data-rli-add]', S.el).forEach(function (b) {
      b.classList.toggle('rli-done', !!c);
      b.disabled = !S.lines.length;
      if (c) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
    qsa('[data-rli-confirm]', S.el).forEach(function (box) {
      box.hidden = !c;
      if (c) qs('[data-rli-cline]', box).textContent = t.confirmLine(c.count, c.total);
    });
    qsa('[data-rli-rlbl]', S.el).forEach(function (s) { s.textContent = c ? t.rerollNew : t.reroll; });
    qsa('.rli-ibbig[data-rli-reroll]', S.el).forEach(function (b) { b.setAttribute('aria-label', c ? t.rerollNew : t.reroll); b.title = c ? t.rerollNew : t.reroll; });
    S.el.classList.toggle('rli-confirmed', !!c);
  }

  function render(S, reason) {
    var fresh = reason === 'compose' || reason === 'reroll' || reason === 'world';
    var animate = fresh || reason === 'edit';
    if (fresh) S.car = 0;
    /* na een wereldovergang: zachtere, iets snellere intrede en de 3D-modellen een voor een aanhaken */
    S.soft = reason === 'world'; S.stagger = reason === 'world';
    /* nieuwe wereld: alle kaarten vers, ook producten die blijven (een kaart met een levend 3D-canvas verplaatsen in de
       DOM laat de motor opnieuw meten en tekenen, een lang frame midden in de overgang); hun 3D wordt later vrijgegeven */
    if (S.stagger) [S.deckEls, S.slideEls, S.fullEls].forEach(function (m) {
      m.forEach(function (n) { qsa('.rli-vis', n).forEach(function (v) { if (v._ctl) attQueue(S, { k: v, p: -1 }); }); n.remove(); });
      m.clear();
    });
    paintFr(S);
    paintPrefs(S);
    if (fresh) S.pg = 0;
    if (S.mode === 'd') renderDeck(S, animate);
    renderSlides(S, animate);
    renderFull(S, animate);
    S.soft = false; S.stagger = false;
    renderEmpty(S);
    if (fresh) { goTo(S, 0, false); S.pg = 0; }
    paintTotals(S);
    paintSel(S);
    paintConfirm(S);
    /* de melding of bevestiging onder de balk kan de voet hoger maken: het vak opnieuw passen */
    if (S.mode === 'd') layoutDeck(S);
    measureSoon(S);
  }

  /* ---------------- knoppen: andere selectie, alles in mijn mandje, bevestiging ---------------- */
  function toast(S, msg) {
    var b = qs('[data-rli-toast]', S.el); if (!b) return;
    qs('[data-rli-toasttxt]', b).textContent = msg;
    b.classList.add('rli-show');
    clearTimeout(S.toastT);
    S.toastT = setTimeout(function () { b.classList.remove('rli-show'); }, 2600);
  }
  /* Andere selectie. Oorzaak van de oude fout: elke klik zocht enkel een mandje dat verschilde van het VORIGE
     (seed + 1 tot het eerste verschil). Bij weinig kandidaten sprong het zo heen en weer tussen twee mixen (A, B, A, B),
     en een "verschil" kon ook enkel een aantal zijn (6 packs in plaats van 5) of een product onder de stapel: voor
     het oog gebeurde er niets. Nu: alles wat binnen hetzelfde budget, dezelfde reeks en voorkeuren al getoond werd,
     wordt onthouden (S.hist). Elke klik zoekt eerst een mix met een ander hoofdproduct, dan een andere set producten;
     om de beurt ook zonder de hoofdproducten die al aan bod kwamen, zodat de stapel echt wisselt. Is alles al eens
     getoond, dan begint de ronde opnieuw (enkel het huidige mandje telt dan als gezien). Pas als er echt niets anders
     bestaat: een korte melding. Synchroon, zonder vlag of timer, dus snel na elkaar klikken loopt nooit vast. */
  var REROLL_TRIES = 60;
  function histKey(S) { return S.budget + '|' + S.franchise + '|' + JSON.stringify(S.typePrefs || null); }
  function setKey(items) { return items.map(function (it) { return it.handle; }).sort().join('|'); }
  function topHandle(items) { var t = null; items.forEach(function (it) { if (!t || it.price > t.price) t = it; }); return t ? t.handle : ''; }
  function histReset(S) { S.hist = { key: histKey(S), sigs: {}, sets: {}, tops: {}, topList: [] }; }
  function histAdd(S, items) {
    if (!S.hist || S.hist.key !== histKey(S)) histReset(S);
    if (!items.length) return;
    var H = S.hist, tp = topHandle(items);
    H.sigs[sig(items)] = 1; H.sets[setKey(items)] = 1;
    if (!H.tops[tp]) { H.tops[tp] = 1; H.topList.push(tp); }
  }
  /* beste kandidaat: rang 1 = ander hoofdproduct, 2 = andere set producten, 3 = enkel andere aantallen */
  /* Vaste soortkeuze (eff.strict): de uitsluiting van eerdere hoofdproducten kan de strikte pool leegmaken, waarna
     composeBasket terugvalt op andere soorten. Daarom bij strict geen uitsluiting, en elke kandidaat die terugvalt
     (prefFallback) terwijl het basismandje dat niet doet, telt niet: nooit producten buiten de gekozen soort.
     Tijdslimiet: de zoeklus stopt na REROLL_MS, zodat een klik nooit merkbaar hapert. */
  var REROLL_MS = 25;
  function nowMs() { return (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now(); }
  function rerollSearch(S, base) {
    var H = S.hist, st = { budget: S.budget, franchise: S.franchise, typePrefs: S.typePrefs }, best = null;
    var eff = effectiveTypePrefs(S.ctx, st), t0 = nowMs();
    var baseFb = composeFor(S.ctx, st, base, S.seed).prefFallback === true;
    var exTops = eff.strict ? [] : H.topList.slice();
    for (var i = 1; i <= REROLL_TRIES; i++) {
      if (i > 1 && nowMs() - t0 > REROLL_MS) break;
      var seed = S.seed + i, prods = base;
      if (i % 2 === 0 && exTops.length) {
        prods = base.filter(function (p) { return exTops.indexOf(p.handle) === -1; });
        if (!prods.length) prods = base;
      }
      var res = composeFor(S.ctx, st, prods, seed), items = res.items || [];
      if (!items.length || H.sigs[sig(items)]) continue;
      /* vaste soort: nooit een kandidaat die terugvalt op andere soorten (ook niet na Alles in mijn mandje) */
      if (res.prefFallback === true && (eff.strict || !baseFb)) continue;
      var rank = !H.tops[topHandle(items)] ? 1 : !H.sets[setKey(items)] ? 2 : 3;
      /* enkel andere aantallen is geen andere mix */
      if (rank > 2) continue;
      if (!best || rank < best.rank) best = { rank: rank, seed: seed, items: items };
      if (rank === 1) break;
    }
    return best;
  }
  function reroll(S, btn) {
    fxFlush(S);
    /* vaste soort zonder iets in het budget: geen terugval op andere soorten, enkel de melding */
    if (S.typeMiss) {
      toast(S, S.t.emptyType);
      if (!S.RM && btn) { btn.classList.remove('rli-shake'); void btn.offsetWidth; btn.classList.add('rli-shake'); }
      return;
    }
    var c = S.confirmed;
    /* na "Alles in mijn mandje": een nieuwe selectie zonder de net toegevoegde producten (zoals start-scene) */
    var ex = c ? c.items.map(function (it) { return it.handle; }) : null;
    var base = (S.ctx.products || []).filter(function (p) { return p && (!ex || ex.indexOf(p.handle) === -1); });
    histAdd(S, S.lines);
    var best = rerollSearch(S, base);
    if (!best) {
      /* alles binnen dit budget is al eens getoond: nieuwe ronde, enkel het huidige mandje telt als gezien */
      var keep = S.hist; histReset(S); histAdd(S, S.lines);
      var again = rerollSearch(S, base);
      if (again) best = again; else S.hist = keep;
    }
    qsa('[data-rli-reroll] .rli-spin', S.el).forEach(function (sp) {
      if (S.RM || !sp.animate) return;
      sp.animate([{ transform: 'rotate(0)' }, { transform: 'rotate(360deg)' }], { duration: 600, easing: 'cubic-bezier(.22,1,.36,1)' });
    });
    if (!best) {
      /* "probeer Alles" enkel buiten Alles */
      /* "probeer Alles" / "alle soorten" enkel als een franchise of een eigen keuze de oorzaak is */
      var fl = filterInfo(S);
      toast(S, fl ? S.t.noMixF : S.franchise !== 'mix' ? S.t.noMix : S.lines.length ? S.t.onlyOne : S.t.noMixAll);
      if (fl) { S.noOther = true; paintNote(S); }
      if (!S.RM && btn) { btn.classList.remove('rli-shake'); void btn.offsetWidth; btn.classList.add('rli-shake'); }
      return;
    }
    S.seed = best.seed;
    S.lines = cloneItems(best.items); S.isManual = false; S.replaceSeen = {};
    S.gen = (S.gen || 0) + 1; S.noOther = false;
    histAdd(S, S.lines);
    saveSeed(S.budget, S.franchise, S.seed);
    changed(S);
    render(S, 'reroll');
  }
  /* vertrekpunt van de vlucht per product: zijn beeld in de stapel (desktop) of de carrousel (gsm) als dat in beeld
     staat, anders de rij of de kaart onderaan; niets in beeld: de pagina vliegt vanaf de knop (data-cws-addmany) */
  function fromFor(S, h) {
    var maps = S.mode === 'd' ? [S.deckEls, S.fullEls] : [S.slideEls, S.fullEls];
    var box0 = S.sc.getBoundingClientRect(), dk = qs('[data-rli-deck]', S.el), dbox = dk ? dk.getBoundingClientRect() : box0;
    for (var i = 0; i < maps.length; i++) {
      var n = maps[i].get(h); if (!n) continue;
      var im = qs('.rli-fb img', n) || qs('img', n); if (!im) continue;
      /* in de strook telt enkel wat binnen de strook zelf zichtbaar is (opzij weggeschoven = niet in beeld) */
      var r = im.getBoundingClientRect(), box = maps[i] === S.deckEls ? dbox : box0;
      if (r.width < 4 || r.bottom < box.top || r.top > box.bottom || r.right < box.left || r.left > box.right) continue;
      return { x: r.left + r.width / 2, y: r.top + r.height / 2, w: clamp(r.width * .9, 60, 150) };
    }
    return null;
  }
  function addAll(S, btn) {
    fxFlush(S);
    if (!S.lines.length || S.confirmed) return;
    /* app.js neemt per item hoogstens 20 stuks: grotere aantallen (groot budget) in porties van 20 doorgeven */
    var items = [];
    S.lines.forEach(function (l) {
      var f = fromFor(S, l.handle), left = l.qty;
      while (left > 0) { var q = Math.min(20, left), it = { handle: l.handle, qty: q }; if (f) it.from = f; items.push(it); left -= q; }
    });
    /* de knop die werd aangeklikt is het terugvalvertrekpunt van de vlucht in app.js */
    qsa('[data-cws-addmany]', S.el).forEach(function (b) { b.removeAttribute('data-cws-addmany'); });
    btn.setAttribute('data-cws-addmany', '');
    if (S.ctx.on && S.ctx.on.addMany) S.ctx.on.addMany(items);
    S.confirmed = { items: cloneItems(S.lines), total: total(S), count: units(S) };
    paintConfirm(S);
    peekCart(S, items.length);
  }
  /* Na "Alles in mijn mandje" klapt de echte mandjelade van de pagina kort open, zodat je ziet dat alles erin landt.
     De Clean-laag doet dat zelf (watchCart: meer stuks in het mandje = lade open, na 2,6 s weer dicht) zodra de vluchten
     geland zijn. Enkel als die lade dan nog niet open ging, roepen we het pad van de pagina aan (ctx.on.openCart; op
     gsm opent dat het mandjeblad). Niets aan de Clean-laag zelf. */
  function peekCart(S, n) {
    clearTimeout(S.peekT);
    S.peekT = setTimeout(function () {
      if (!getState(S.el)) return;
      var b = document.body;
      if (b.classList.contains('cl-cart') || (qs('.sheet.on') && S.mode === 'm')) return;
      if (S.ctx.on && S.ctx.on.openCart) S.ctx.on.openCart();
    }, 1500 + Math.min(n, 12) * 120);
  }
  function wireButtons(S) {
    S.on(S.el, 'click', function (e) {
      var b = e.target.closest('[data-rli-add],[data-rli-reroll],[data-rli-cart],[data-rli-undo],[data-rli-hint]');
      if (!b || !S.el.contains(b)) return;
      if (b.hasAttribute('data-rli-add')) addAll(S, b);
      else if (b.hasAttribute('data-rli-reroll')) reroll(S, b);
      else if (b.hasAttribute('data-rli-cart')) { if (S.ctx.on && S.ctx.on.openCart) S.ctx.on.openCart(); }
      else if (b.hasAttribute('data-rli-undo')) {
        var c = S.confirmed; if (!c) return;
        if (S.ctx.on && S.ctx.on.removeMany) S.ctx.on.removeMany(c.items.map(function (it) { return { handle: it.handle, qty: it.qty }; }));
        S.confirmed = null; clearTimeout(S.peekT); paintConfirm(S);
      } else if (b.hasAttribute('data-rli-hint')) {
        var top = S.full.getBoundingClientRect().top - S.sc.getBoundingClientRect().top + S.sc.scrollTop - 8;
        S.sc.scrollTo({ top: Math.max(0, top), behavior: S.RM ? 'auto' : 'smooth' });
      }
    });
  }

  /* ---------------- interne scroll en parallax ----------------
     De feed is een rij scenes van 100dvh met scroll-snap. Deze component scrolt BINNEN zijn eigen container
     (.rli-scroll): het app-vlak is precies de hoogte van de scene, je volledige mandje staat eronder.
     Keuze (veiligste route):
     - Desktop met de Clean-laag in Rip Lab (body.cl-lab): de feed staat daar vast (overflow hidden, positie elke tick
       hersteld). De interne scroll krijgt dan overscroll-behavior: contain (css), niets lekt naar de pagina.
     - Overal elders (gsm, desktop zonder Clean): overscroll-behavior-y blijft auto. Dan scrolt eerst de interne
       container; staat die aan zijn begin of einde, dan neemt de browser bij de volgende veeg of het volgende
       wieltje de feed mee (gewone scroll-chaining) en snapt die zoals nu naar de vorige of volgende scene. Geen
       niet-passieve wheel- of touchlistener, geen eigen snapcode: de feed-navigatie blijft die van de pagina.
     - Toetsenbord: pijl omlaag, Page Down en spatie scrollen eerst intern zolang dat kan; aan de rand gaat de
       toets door naar de feed (de documentlistener van app.js), zoals nu.
     Parallax: enkel transform en opacity, een rAF per scrollframe, posities uit een cache (geen layoutmeting per
     frame), nooit een transform op het 3D-vak zelf, enkel op wrappers (.rli-drift, .rli-fcard, .rli-move). */
  function wireScroll(S) {
    var sc = S.sc;
    S.on(sc, 'scroll', function () { if (!S.pxRaf) S.pxRaf = requestAnimationFrame(function () { S.pxRaf = 0; pxFrame(S); }); }, { passive: true });
    S.on(S.el, 'keydown', function (e) {
      var tag = (e.target && e.target.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA' || e.altKey || e.ctrlKey || e.metaKey) return;
      var k = e.key, dir = 0, amt = 0, H = sc.clientHeight;
      if (k === 'ArrowDown') { dir = 1; amt = 80; } else if (k === 'ArrowUp') { dir = -1; amt = 80; }
      else if (k === 'PageDown' || (k === ' ' && !e.target.closest('button,[role="button"]'))) { dir = 1; amt = H * .85; }
      else if (k === 'PageUp') { dir = -1; amt = H * .85; }
      if (!dir) return;
      var max = sc.scrollHeight - sc.clientHeight;
      if ((dir > 0 && sc.scrollTop >= max - 2) || (dir < 0 && sc.scrollTop <= 2)) return; /* rand: de feed neemt over */
      e.preventDefault(); e.stopPropagation();
      sc.scrollBy({ top: dir * amt, behavior: S.RM ? 'auto' : 'smooth' });
    });
  }
  function ease3(x) { return 1 - Math.pow(1 - x, 3); }
  function measureSoon(S) {
    if (S.RM || S.measRaf) return;
    S.measRaf = requestAnimationFrame(function () { S.measRaf = 0; if (!getState(S.el)) return; measure(S); pxFrame(S); });
  }
  function measure(S) {
    var PX = S.px, sc = S.sc, sy = sc.scrollTop, sr = sc.getBoundingClientRect();
    PX.vh = sc.clientHeight; PX.vw = sc.clientWidth; PX.mob = S.mode === 'm';
    PX.appH = S.app.offsetHeight || 1;
    PX.maxS = Math.max(0, sc.scrollHeight - sc.clientHeight);
    var deck = qs('[data-rli-deck]', S.el), dr = deck.getBoundingClientRect();
    var dTop = dr.top - sr.top + sy, dLeft = dr.left - sr.left, deckOn = !PX.mob && dr.width > 0 && dr.height > 0;
    var dcx = dLeft + dr.width / 2, dcy = dTop + dr.height / 2;
    PX.deck = [];
    /* per product in de strook: het midden van zijn beeld (in scrollcoordinaten), enkel als het in de strook zichtbaar is */
    var stageAt = {};
    if (deckOn) deckItems(S).forEach(function (l, r) {
      var c = S.deckEls.get(l.handle); if (!c) return;
      var st = qs('.rli-cstage', c), d = qs('.rli-drift', c);
      if (d) { d.style.transform = ''; d.style.opacity = ''; }
      var cr = st.getBoundingClientRect();
      if (cr.right > dr.left && cr.left < dr.right) stageAt[l.handle] = { x: cr.left - sr.left + cr.width / 2, y: cr.top - sr.top + sy + cr.height / 2 };
      PX.deck.push({ d: d, r: r, last: '' });
    });
    PX.items = [];
    S.lines.forEach(function (l, k) {
      var li = S.fullEls.get(l.handle); if (!li) return;
      var fr = qs('.rli-frame', li), mv = qs('.rli-move', li);
      li.style.transform = ''; /* meten zonder de eigen verschuiving */
      var lr = li.getBoundingClientRect(), frr = fr.getBoundingClientRect();
      var top = lr.top - sr.top + sy;
      var fx = frr.left - sr.left + frr.width / 2, fy = frr.top - sr.top + sy + frr.height / 2;
      var sx = dcx, sY = dcy, at = stageAt[l.handle];
      if (at) { sx = at.x; sY = at.y; }
      PX.items.push({ li: li, mv: mv, top: top, k: k, dx: deckOn ? sx - fx : 0, dy: deckOn ? sY - fy : 0, lastL: '', lastM: '', lastO: '' });
    });
    PX.ok = true;
  }
  function pxFrame(S) {
    var PX = S.px;
    if (S.RM || !PX.ok) return;
    var sy = S.sc.scrollTop, vh = PX.vh, mob = PX.mob;
    var bt = 'translate3d(0,' + (Math.max(0, sy) * (mob ? 0.14 : 0.3)).toFixed(1) + 'px,0)';
    if (bt !== PX.lastB) { PX.lastB = bt; qsa('.rli-bv', S.el).forEach(function (b) { b.style.transform = bt; }); }
    var hint = qs('[data-rli-hint]', S.el), ho = mob ? '1' : (1 - clamp(sy / 180, 0, 1)).toFixed(3);
    if (hint && ho !== PX.lastH) { PX.lastH = ho; hint.style.opacity = ho; hint.style.pointerEvents = +ho < 0.1 ? 'none' : ''; }
    var q = clamp(sy / (PX.appH * 0.8), 0, 1), e = q * q;
    PX.deck.forEach(function (d) {
      if (!d.d) return;
      var tr = 'translate(0,' + (e * (24 + (d.r % 3) * 10)).toFixed(1) + 'px)', op = (1 - 0.5 * e).toFixed(3);
      /* verschoven: dan vangt het beeld geen klik meer (het balkje eronder blijft gewoon klikbaar) */
      var nope = e > 0.02;
      if (nope !== d.nope) { d.nope = nope; d.d.classList.toggle('rli-nope', nope); }
      if (tr + op === d.last) return;
      d.last = tr + op; d.d.style.transform = tr; d.d.style.opacity = op;
    });
    var span = vh * (mob ? 0.45 : 0.6), maxUp = mob ? vh * 0.08 : vh * 0.55, maxX = PX.vw * 0.35;
    PX.items.forEach(function (it) {
      var s0 = it.top - vh, s1 = Math.min(s0 + span, PX.maxS), p;
      if (s1 <= 0) p = 1;
      else { var a = Math.min(s0, s1 - 40); p = clamp((sy - a) / (s1 - a), 0, 1); }
      var ec = ease3(p), off = mob ? 26 + (it.k % 2) * 16 : 70 + (it.k % 3) * 55;
      var lx = mob ? 0 : (it.k % 2 ? 1 : -1) * 28 * (1 - ec), ly = off * (1 - ec);
      var trL = 'translate(' + lx.toFixed(1) + 'px,' + ly.toFixed(1) + 'px)';
      if (trL !== it.lastL) { it.lastL = trL; it.li.style.transform = trL; }
      var pv = clamp((p - 0.04) / 0.86, 0, 1), ev = ease3(pv);
      var dx = mob ? 0 : clamp(it.dx, -maxX, maxX), dy = mob ? -maxUp : clamp(it.dy, -maxUp, 0);
      var trM = 'translate(' + (dx * (1 - ev) - lx).toFixed(1) + 'px,' + (dy * (1 - ev) - ly).toFixed(1) + 'px)';
      var om = clamp(pv * 1.8, 0, 1).toFixed(3);
      if (trM !== it.lastM) { it.lastM = trM; it.mv.style.transform = trM; }
      if (om !== it.lastO) { it.lastO = om; it.mv.style.opacity = om; }
      /* Zolang het model nog onderweg is (onzichtbaar of omhoog verschoven naar de stapel) vangt het geen klik: anders ligt
         het 3D-vak van een regel, met opacity 0, over de knoppen (Andere selectie) en gebeurt er niets. */
      var pe = ev < 0.98 ? 'none' : '';
      if (pe !== it.lastP) { it.lastP = pe; it.mv.style.pointerEvents = pe; }
    });
  }

  /* gsm: de PiP (rechtsboven, app.js) mag de titel en de keuzes niet bedekken: ruimte rechts (en links, om centraal
     te blijven) naast de titel, en de stappen (franchise eerst) zakken net onder de PiP. Zonder PiP of op desktop: niets. */
  function pipClear(S) {
    var el = S.el, pip = document.getElementById('pip'), w = 0, need = 0;
    var sl = qs('.rli-body', el);
    /* enkel bovenaan meten: tijdens de interne scroll niets verschuiven (anders springt de inhoud) */
    if (S.mode === 'm' && S.sc.scrollTop >= 4) return;
    if (S.mode === 'm' && pip) {
      var pr = pip.getBoundingClientRect(), er = el.getBoundingClientRect();
      var vis = pr.width > 0 && pr.height > 0 && getComputedStyle(pip).display !== 'none' && getComputedStyle(pip).visibility !== 'hidden' && !pip.hidden;
      if (vis && pr.bottom > er.top && pr.top < er.bottom && pr.left < er.right) {
        w = Math.max(0, Math.round(er.right - pr.left + 8));
        if (sl) {
          sl.style.marginTop = '';
          var sr = sl.getBoundingClientRect();
          need = Math.max(0, Math.round(pr.bottom + 8 - sr.top));
          /* de css-marge (10 px op gsm) blijft staan: de inline marge is die marge plus wat nog nodig is */
          if (need) need += parseFloat(getComputedStyle(sl).marginTop) || 0;
        }
      }
    }
    el.style.setProperty('--rli-pip-w', w + 'px');
    if (sl) sl.style.marginTop = need ? need + 'px' : '';
  }

  /* ---------------- replay / unmount ---------------- */
  function replay(root) {
    var el = findRoot(root), S = el && getState(el); if (!S || S.RM) return;
    S.deckEls.forEach(function (c, h) {
      if (!c.animate) return;
      var i = idxOf(S, h);
      c.animate([{ opacity: 0, transform: 'translateY(40px)' }, { opacity: 1, transform: 'none' }], { duration: 600, delay: 40 + Math.min(6, Math.max(0, i)) * 70, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
    });
  }
  function unmount(root) {
    var el = findRoot(root), S = el && getState(el);
    if (S) {
      S.timers.forEach(function (id) { clearTimeout(id); }); clearTimeout(S.bgT); clearTimeout(S.toastT); clearTimeout(S.peekT);
      fxStop(S); cancelAnimationFrame(S.swayRaf || 0); S.swayRaf = 0; attFlush(S); clearTimeout(S.preT);
      S.intervals.forEach(function (id) { clearInterval(id); });
      S.offs.forEach(function (f) { try { f(); } catch (e) { /* negeren */ } });
      if (S.ro) { try { S.ro.disconnect(); } catch (e) { /* negeren */ } }
      if (S.mo) { try { S.mo.disconnect(); } catch (e) { /* negeren */ } }
      clearTimeout(S.enterT);
      if (PROBE && PROBE.parentNode) PROBE.parentNode.removeChild(PROBE);
      PROBE = null;
      cancelAnimationFrame(S.pxRaf || 0); cancelAnimationFrame(S.measRaf || 0); cancelAnimationFrame(S.roRaf || 0); cancelAnimationFrame(S.cRaf || 0);
      S.tweenId = (S.tweenId || 0) + 1; S.totId = (S.totId || 0) + 1;
      killIn(el);
      var host = el.parentNode; if (host && host.classList) { host.classList.remove('rli-host'); unfit(host); }
    }
    if (el) setState(el, null);
  }

  var API = { html: html, mount: mount, replay: replay, unmount: unmount };
  window.CWStartI2C = API;

  /* ---------------- schakelaar ----------------
     Standaard blijft de huidige Rip Lab (window.CWStart van start-scene.js, of rip-lab.js bij RIPLAB_NIEUW=1).
     ?riplab=i2c: deze variant, onthouden voor de rest van de tab (sessionStorage); ?riplab=oud: terug naar de huidige;
     ?riplab=nieuw is sinds 9 okt de wizard-variant (rip-lab-wiz.js, geladen na dit script) en zet deze variant uit.
     Dit script staat in de pagina NA start-scene.js en VOOR app.js, dus app.js leest hier al de gekozen component. */
  var KEY = 'cw-riplab-i2c', want = false;
  try {
    var q = new URLSearchParams(location.search).get('riplab');
    if (q === 'i2c') sessionStorage.setItem(KEY, '1');
    else if (q === 'oud' || q === 'nieuw') sessionStorage.removeItem(KEY);
    want = q === 'i2c' || (q !== 'oud' && q !== 'nieuw' && sessionStorage.getItem(KEY) === '1');
  } catch (e) { want = /[?&]riplab=i2c\b/.test(location.search); }
  if (want) {
    window.CWStartOud = window.CWStart || null;
    window.CWStart = API;
    try { document.documentElement.classList.add('rli-active'); } catch (e) { /* negeren */ }
  }
  /* richting van de linkerkolom: ?links=a|b|c, onthouden voor de tab (sessionStorage); de keuzepil rechtsboven enkel
     in deze testopstelling (?riplab=nieuw), zodat Andrea de drie kan vergelijken */
  LINKS.sw = want;
  try {
    var lq = new URLSearchParams(location.search).get('links');
    if (LINKS_VALS.indexOf(lq) !== -1) sessionStorage.setItem(LINKS_KEY, lq);
    var lv = sessionStorage.getItem(LINKS_KEY);
    if (LINKS_VALS.indexOf(lv) !== -1) LINKS.v = lv;
  } catch (e) {
    var lm = /[?&]links=([abc])\b/.exec(location.search); if (lm) LINKS.v = lm[1];
  }
})();

